<template minapp="mpx" xlang="wxml">
  <es-over-layout
    custom-class="{{customClass}}"
    layout="{{['header', 'footer']}}"
    useDefaultNavbar="{{false}}"
    needScroll="{{true}}"
    blankPageType="blank-page"
    useBlankPage="{{useBlankPage}}"
    blankImageUrl="{{blankImageUrl}}"
    blankContextTitle="{{blankContextTitle}}"
    blankContextSubTitle="{{blankContextSubTitle}}"
    hasBlankButton="{{hasButton}}"
    bind:blank-retry="loadOrderBaseInfo"
    navbarClickLeft="{{goBackReport}}"
    bind:onscroll="handleScroll"
  >
    <view slot="header">
      <es-navbar
        wx:style="{{navbarStyle}}"
        left-arrow="{{true}}"
        bind:click-left="goBackReport"
        custom-class="{{scrambleNavBar}}"
        customFillboxClass="{{scrambleFillBox}}"
      >
        <block wx:if="{{!fromChangeTicket}}">
          <view wx:if="{{isFromScramble || !userGroup}}" class="es-navbar-title">{{ titleBar }}</view>
          <view class="es-navbar-title" wx:else>
            <date-card
              wx:ref="date_card"
              value="{{time}}"
              date-type="{{'MM-dd'}}"
              checkType="single"
              linking="{{linking}}"
              isUpdateEveryTime="{{true}}"
              checkRange="{{7}}"
              dateType="M月d日"
              maxDate="{{maxDateTime}}"
              minDate="{{minDateTime}}"
              maxHeaderDate="{{headerMaxDateTime}}"
              minHeaderDate="{{headerMinDateTime}}"
              startText="去程"
              endText="返程"
              title="选择前往日期"
              closeable="{{true}}"
              disable="{{dateCardDisabled}}"
              bind:confirm="onConfirm"
              bind:handleClickDay="handleClickDay"
              bind:reportClick="dateCardClickReport"
            />
          </view>
        </block>
        <change-navbar process="{{2}}" wx:else title="{{titleBar}}" />
        <view wx:if="{{isFromScramble || userGroup}}" slot="right">
          <view class="es-navbar-right" bindtap="sideTitle.jumpFn">{{ sideTitle.text }}</view>
        </view>
      </es-navbar>
    </view>
    <block slot="bg-icon" wx:if="{{isFromScramble && !loadInitDataFail}}">
      <image
        mode="widthFix"
        src="https://img-hxy021.didistatic.com/static/starimg/img/8rhBDFRo381693374074807.png"
        class="scrambling-bg"
      />
    </block>
    <!-- 主内容区 -->
    <view
      class="card-main"
      bindscroll="handleScroll"
      wx:class="{{!isFromScramble && 'notscramble'}}"
      wx:if="{{showTrainInfomation}}"
    >
      <probability probability="{{scrableSuccessRate}}" wx:if="{{isFromScramble}}" />
      <image
        wx:if="{{isFromScramble}}"
        class="scramble-text-pic"
        src="https://img-hxy021.didistatic.com/static/starimg/img/CJc2VEHDB81692188876513.png"
      />
      <block wx:if="{{isFromScramble}}">
      <!-- 抢票车次信息-->
        <scramble-select-card
          trainCodeList="{{trainCodeList}}"
          startDateList="{{startDateList}}"
          selectDateCurList="{{selectDateCurList}}"
          selectDateList="{{selectDateList}}"
          trainSeatList="{{trainSeatList}}"
          selectSeatCodeList="{{selectSeatCodeList}}"
          lastSelectedSeatIndex="{{lastSelectedSeatIndex}}"
          deadLineHour="{{selectDeadline}}"
          bind:openDeadLine="openDeadLine"
          bind:setSelectDateCurList="setSelectDateCurList"
          bind:setSelectSeatCodeList="setSelectSeatCodeList"
        />
      </block>
      <block wx:elif="{{isTransfer}}">
        <transfer-info-card
          wx:ref="transferCard"
          isExemption="{{!!isExemption}}"
          trainInfo="{{trainInfo}}"
          hasRightsChoosed="{{hasRightsChoosed}}"
          bind:showSSI="showSSI"
        />
      </block>
      <block wx:elif="{{isRecommendTicket}}">
         <!-- 多买少买 车次信息-->
        <recommend-ticket-card wx:style="{{{'margin': '0 -12px' }}}" makeOrder/>
      </block>
      <block wx:else>
        <!-- 普通车次信息-->
        <view class="new-train-card">
          <train-information-new
            wx:style="{{{'z-index': '1','position': 'relative'}}}"
            noDetail="{{!!userGroup}}"
            bind:click="showSSI"
            trainInfo="{{trainInfo}}"
          />
          <view  wx:if="{{userGroup && hasRightsChoosed}}" class="selected-seat-info">{{ hasSelectedSeatPrice }}</view>
          <view wx:if="{{userGroup}}" wx:style="height:12px"></view>
          <block wx:if="{{!userGroup}}">
            <!-- 已选择的座位信息 -->
            <view class="seat-info">
              <view class="seat-info-left">
                <view class="seat-info-left-type">{{ ticketType }}</view>
                <view class="seat-info-left-price">{{ ticketPrice }}</view>
                <view wx:if="{{offlineHandingFee}}" class="service-writting">
                  便捷购票¥{{ offlineHandingFee }}
                </view>
              </view>
              <view class="seat-info-right" bindtap="sideTitle.jumpFn">
                <image class="seat-info-right-image" src="https://ut-static.udache.com/webx/sfc/j9QJ2xhfiMsq3IjQ5Bdf9.png" />
                <text>{{ sideTitle.text }}</text>
              </view>
            </view>
          </block>
        </view>
      </block>
      <coupon-banner-simplify wx:if="{{!hasRightsChoosed && !isFromScramble && !isRecommendTicket}}" from="makeOrder" />
      <view class="divider" />
      <!-- 坐席信息 -->
      <block wx:if="{{userGroup && !this.isFromScramble && !isRecommendTicket}}">
       <seat-information-group
        wx:if="{{!fromChangeTicket}}"
        isStudent="{{isStudent}}"
        hasRightsChoosed="{{hasRightsChoosed}}"
       />
       <seat-information-new
        wx:else
        wx:style="margin-bottom: 10px;"
        isStudent="{{isStudent}}"
        fromChangeTicket="{{fromChangeTicket}}"
        isPreScramble="{{isPreScramble}}"
        bind:reportClick="seatInfoClickReport"
        />
      </block>
      <!-- 免登前置 -->
      <block>
        <!-- 普通购票未选择和抢票 -->
        <seat-rights-select-group
          wx:ref="rightsSelectGroup"
          wx:style="{{{'margin-top': hasRightsChoosed ? '0' : '10px'}}}"
          wx:if="{{!fromChangeTicket && !isFromScramble && !isRecommendTicket}}"
          hasRightsChoosed="{{hasRightsChoosed}}"
          bind:reportClick="seatInfoClickReport"
          bind:selectSeatRights="selectSeatRights"
          bind:openRightsDescDrawer="openServiceDescDrawer"
        />
      </block>
      <!-- 多买少买推荐坐席 -->
      <block wx:if="{{userGroup && !this.isFromScramble && !this.isTransfer && !isRecommendTicket && !fromChangeTicket}}">
       <seat-information-recommend
          wx:style="margin-bottom: 10px;"
          isStudent="{{isStudent}}"
          hasRightsChoosed="{{hasRightsChoosed}}"
          fromChangeTicket="{{fromChangeTicket}}"
          isPreScramble="{{isPreScramble}}"
          bind:reportClick="seatInfoClickReport"
        />
      </block>

      <block>
        <!-- 未登陆引导 -->
        <view
          class="no-account"
          wx:style="{{mainStyle}}"
          wx:if="{{!fromChangeTicket && !isFromScramble && !is12306Login && !valueAddedServices}}"
        >
          <view class="no-account-left">
            <image
              class="no-account-left-icon"
              src="https://ut-static.udache.com/webx/sfc/TGk18Kq3oyt6CtSD34ugT.png"
            />
            <view class="no-account-left-text">登录12306</view>
          </view>
          <view class="no-account-right" bindtap="openLoginDrawer" tabindex="0">
            <view class="no-account-right-text">去登录</view>
            <image
              class="no-account-right-icon"
              src="https://ut-static.udache.com/webx/sfc/ABpMMfCY4hCXirn-kGe0A.png"
            />
          </view>
        </view>
      </block>

      <Slogan 
        wx:class="slogan"
        wx:if="{{!fromChangeTicket && !isFromScramble && !isRecommendTicket && !hasRightsChoosed}}" 
        sloganIcon="https://ut-static.udache.com/webx/sfc/blxxpny0xNRP_MD-onS94.png"
      />
 
      <view wx:style="{{mainStyle}}">
        <block>
          <!-- 乘车人模块 -->
          <block wx:if="{{fromChangeTicket}}">
            <!-- 改签 - 公告文案 -->
            <change-tip />
            <!-- 改签 - 更改乘车人 -->
            <passenger-change-check-list
              passengers="{{passengersForChange}}"
              bind:check="checkPassengersForChange"
            />
          </block>
          <!-- 预定 - 选择乘车人 -->
          <view class="passenger-card" wx:else>
            <passenger-make-order-card
              bind:list="setPassengerList"
              bind:select="setCurPassengerIndexList"
              passengerSource="{{passengerSource}}"
              showArrow="{{false}}"
              passengerList="{{currentPassengerList}}"
            />
            <view class="passenger-card-add" bindtap="addPassenger">
              <image class="passenger-card-add-icon" src="{{passengerAddIcon}}" />
              <text
                class="link-btn-text passenger-card-add-text"
                wx:class="{{isFromScramble && 'passenger-add-text-black'}}"
                >{{ passengerAddText }}</text
              >
            </view>
          </view>
        </block>

        <block wx:if="{{!fromChangeTicket}}">
          <view class="contact-phone">
            <view class="form-label contact-item">联系手机</view>
            <view class="form-value">
              <input
                type="text"
                ref="telephone"
                class="contact-item contact-phone-input"
                placeholder="用于接受确认短信"
                placeholderStyle="color: #cccccc"
                bindinput="onPhoneChange($event)"
                wx:model="{{phoneNum}}"
              />
              <view wx:class="{{ {'error-tip':true,active:phoneCheckDesc} }}">{{
                phoneCheckDesc
              }}</view>
            </view>
          </view>
        </block>

        <!-- 加速包选择卡片 -->
        <package-channel wx:if="{{isFromScramble}}" />
        
        <!-- 双通道抢票卡片 -->
        <dual-channel wx:if="{{isFromScramble}}" />

        <block wx:if="{{isSupportChooseSeats}}">
          <select-seat-card
            wx:for="{{selectSeatInfo}}"
            wx:key="index"
            wx:if="{{!isFromScramble}}"
            seatIndex="{{index}}"
            supportChoose="{{notSleeperSeat(item,index)}}"
            bindhandle="onSeatClick"
            bindsilent="onSilentClick"
            seatLength="{{getSeatLength(item)}}"
            bind:click="showTips"
            max="{{fromChangeTicket ? checkedPassengersForChange.length : curPassengerIndexList.length}}"
            isMute="{{makeOrderInfo.special_flag === 1 ? true:false}}"
            isTransfer="{{isTransfer}}"
          />
        </block>
        
        <!--选择普通预定展示辅营：退改无忧/便携购票-->
        <block wx:if="{{regularService}}">
          <make-order-service-business
            bind:openRightsDescDrawer="openServiceDescDrawer"
          />
        </block>

        <block wx:if="{{!regularService && showRightsDescBar && !fromChangeTicket}}" >
          <service-desc-bar 
            bind:openRightsDescDrawer="openServiceDescDrawer"
          />
        </block>

        <view wx:if="{{licenseCheckedDefault}}" class="protocol-container">
          <view class="protocol-text" wx:class="{{{'text-color': licenseAgreementSelected}}}" bindtap="licenseClick">{{
            reminders != null ? reminders.purchase_service : ''
          }}</view>
          <view
            class="protocol-url"
            wx:class="{{{'url-color': licenseAgreementSelected}}}"
            bindtap="jumpToH5(item, index)"
            wx:for="{{purchaseList}}"
          >
            《{{ item.name }}》
          </view>
        </view>
        <view wx:if="{{isFromScramble}}" class="scramble-icon-wrapper">
          <image
            class="scramble-icon"
            src="https://img-hxy021.didistatic.com/static/starimg/img/jPvZLTRgZs1692788014403.png"
          />
        </view>
      </view>
    </view>

    <view
      wx:style="{{footStyle}}"
      wx:if="{{!loadInitDataFail}}"
      slot="footer"
      class="footer"
      wx:class="{{{'footer-fixed': isDetailShow}}}"
    >
      <view wx:if="{{trainInfo.is_ticket_period && userGroup && !isFromScramble && !fromChangeTicket && !valueAddedServices}}" class="exemption-tips">
        <view class="exemption-tips-price">便携购票 +{{offlineHandingFee}}/人</view>
        <view class="exemption-tips-text">该时段12306暂不支持购票，滴滴支持夜间正常出票</view>
      </view>
      <order-bottom-bar
        canPay="{{canPay}}"
        reminders="{{reminders}}"
        purchaseList="{{purchaseList}}"
        totalFeeInfo="{{totalFeeInfo}}"
        licenseAgreementSelected="{{licenseAgreementSelected}}"
        licenseCheckedDefault="{{licenseCheckedDefault}}"
        isDetailShow="{{isDetailShow}}"
        isFromScramble="{{isFromScramble}}"
        changeTip="{{ fromChangeTicket ? '高价更改低价票，差额部分按照现行退票规则收取手续费，具体收费明细请查看改签预订须知。' : '' }}"
        bind:click="licenseClick"
        bind:submit="beforeSubmitOrder"
        bind:closeDetail="closeDetail"
        bind:changeDetail="changeDetail"
        studentLength="{{studentLength}}"
        isExemption="{{isExemption}}"
      />
      
    </view>

  </es-over-layout>
  <!-- 通用Dialog -->
  <es-dialog id="es-dialog" />
  <!-- 协议弹窗 -->
  <es-dialog id="es-dialog-book">
    <view class="bottom-conceal-text" slot="content">
      我阅读并同意以下协议
      <view
        class="protocol url"
        wx:for="{{purchaseList}}"
        wx:key="index"
        bindtap="jumpToLicense(item, index)"
      >
        《{{ item.name }}》
      </view>
    </view>
  </es-dialog>
  <!-- 时刻表 -->
  <stay-info-drawer
    show="{{ showStayInfo }}"
    title="时刻表"
    isTransfer="{{isTransfer}}"
    stayInfo="{{stayInfo}}"
    stayInfoList="{{stayInfoList}}"
    bind:close="closeSSI"
    bind:setStayInfo="setStayInfo"
  />
  <price-detail-info-alter
    show="{{isDetailShow}}"
    hasBottomBar="{{true}}"
    priceDetailCardTip="{{priceDetailCardTip}}"
    priceDetail="{{priceDetail}}"
    bind:close="closeDetail"
    studentLength="{{studentLength}}"
    title="费用明细"
  />
  <deadline-drawer
    show="{{showDeadline}}"
    latestTrainStartTime="{{latestTrainStartTime}}"
    selectDeadline="{{selectDeadline}}"
    bind:close="closeDeadline"
    bind:set="setSelectDeadline"
  />
  <login-drawer
    login12306Amount="{{login12306Amount}}"
    offlineAmount="{{offlineAmount}}"
    bind:close="closeLoginDrawer"
    bind:check="handleVerification(0)"
    bind:submit="handleVerification(1)"
  />
  <ticketing-notice-drawer
    show="{{showticketNotice}}"
    drawerPrice="{{drawerPrice}}"
    bind:check="handleVerification(1)"
    bind:close="closeTicketNotice"
    bind:getServiceDescription="getServiceDescription"
  />
  <ticketing-notice-drawer
    noticeType="{{1}}"
    show="{{showtikcetPrompt}}"
    contactList="{{errorPassengerList}}"
    bind:close="closeTikcetPrompt"
    bind:addPassenger="addPassenger"
  />
  <login12306-drawer 
    show="{{showLoginDrawer}}" 
    bindclose="closeLoginDrawer"
    bind:submit="handleVerification(1)"
    bind:openRightsDescDrawer="openRightsDescDrawer"
    bind:loginResetPassenger="loginResetPassenger"
    bind:checkPassenger="checkPassenger"
  />
  <!-- 免登说明弹窗 -->
  <nologin-description
    show="{{showServiceDescription}}"
    bind:close="closeServiceDescription"
  />
  <!-- 免登权益说明弹窗 -->
  <rights-description-drawer
    show="{{showRightsDescDrawer}}"
    regularService="{{regularService}}"
    page="makeOrder"
    bindclose="closeRightsDescDrawer"
  />
  <!-- 退改无忧说明弹窗 -->
  <worry-free-cancellation-drawer 
    show="{{showWorryFreeDescDrawer}}" 
    regularService="{{regularService}}"
    bindclose="closeWorryFreeDescDrawer"
    bindchooseRight="chooseWorryFreeService"
  />
  <!-- 普通购票挽留弹窗 -->
  <ticket-retention-drawer 
    show="{{showNormalRetentionDrawer}}" 
    currentPassengerList="{{currentPassengerList}}" 
    bindsubmit="beforeSubmitOrder(false)"
  />
  <!-- 抢票挽留弹窗 -->
  <scramble-retention-drawer 
    show="{{showScrambleRetentionDrawer}}"
    bindsubmit="beforeSubmitOrder(false)"
  /> 
  <!-- 隐私协议 -->
  <es-riskmanagement />
  <es-dialog id="es-dialog-conceal-login">
   <view slot="content">
     <view class="protocol text">我阅读并同意以下协议</view>
     <view class="protocol url" bindtap="gotoAuthorizationAgreement">《个人信息处理授权协议》</view>
     <view class="protocol text">同意受本协议约束</view>
   </view>
  </es-dialog>
</template>

<script>
  import { formatDate as formatDateShare, getDayByOffset, compare } from '@didi/es-mpx-shared'
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { getFullDate } from '@didi/es-mpx-shared/lib/date'
  import { makeOrder,
    makeScrambleOrder,
    makeUnionOrder,
    changeTicketOrder,
    getOrderBaseInfo,
    rememberCheckedProtocol,
    rememberTrainCheckedProtocol,
    getCheckedProtocol,
    getTrainCheckedProtocol,
  } from '@/api/make-order/index'
  import { AES_ECB_ENCRYPT, AES_ECB_DECRYPT } from '@/common/crypto'
  import store from '@/store'
  import { getStorage } from '@/utils/storage'
  import { formatDate } from '../../utils/baseDate'
  import { getFinalPrice } from '../../utils/money'
  import { setStorage } from '../../utils/storage'
  import { isFastDoubleClick } from '@/utils/double-click'
  import {
    MOBILE_CHECK_REG,
    LOAD_FAIL_CONTENT,
    ORDER_SOURCE,
    SLEEPER_SEAT_TYPE,
    ORDERSTATUSINFO,
    FEE_DETAIL_TIPS,
  } from '@/common/constant'
  import {
    STORAGE_LIST_SEARCH_QUERY,
    STORAGE_CURRENT_SELECTED_CITY,
    STORAGE_TRAIN_INFO,
    STORAGE_DETAIL_SEARCH_QUERY,
    STORAGE_SELECT_TICKET,
    STORAGE_SUCCESS_INFO
  } from '@/utils/train-storage'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import Validator from '../../utils/validator'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import { innerRouter, pagePath } from '@/common/jump'
  import { is, query, getURL } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'
  import { makePay } from '@/api/order-detail/index'
  import { payment as payMgr } from '@/bridge'
  import { USER_CONTACTS_TOC } from '@/api/urls'
  import { DIDI_REQUEST } from '@/common/constant'
  import { isToday, isTomorrow } from '@/utils/baseDate'
  import { cloneDeep } from 'lodash'
   import { watchEvent, sendEvent } from '@/utils'

  createPage({
    created() {
      watchEvent('updateMakeOrder', () => this.getTrainDetailFunc())
      this.userGroup && this.getCurrentUserReverse({ init: true })
      this.init()
      const trainListSearchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY) || {}
      const val = new Date(trainListSearchQuery.train_date).getTime() || new Date().getTime()
      this.timeChange(val)
      this.dateTextShow = this.getDays(val)
      if(this.isFromScramble) {
        trackEvent('userteam_train_conorder_sw', 'UT-火车票-车次详情-确认订单页-曝光', {
          ...this.trackEventPublicParams
        })
        this.setScrambleChooseTrains([getStorage(STORAGE_DETAIL_SEARCH_QUERY)])
        this.selectSeatCodeList.push(this.selectSeatInfo[0]?.seat_type_name)
        const index = this.trainSeatList?.findIndex(item => item.seat_name === this.selectSeatInfo[0]?.seat_type_name)
        this.lastSelectedSeatIndex = index === -1 ? 0 :index
        this.deadlineAdapt()
      }
      this.setShowRecommendTickets(true)
    },
    async onShow() {
      this.userGroup && this.getCurrentUserReverse({ init: true })
      if(this.requestForMakeOrderBack) {
        this.setRequestForMakeOrderBack(false)
        this.init()
      }
      if(this.resetSelectSeatForRecommendBack && getURL()?.indexOf('-backup') === -1) {
        this.setResetSelectSeatForRecommendBack(false)
        this.init()
      }
      if(this.checkForBack) {
        this.is12306Login && this.checkForBack === 1 && this.checkPassenger()
        this.is12306Login && this.checkForBack === 2 && this.checkPassenger(0)
        this.checkForBack = 0
      }
    },
    data() {
      return {
        getTravelListFlag:false,
        navbarStyle: {
          'font-size': '18px',
          'font-weight': 600,
          color: '#000000',
          'font-family': 'PingFangSC',
          'background-color': '#fff'
        },
        loadInitDataFail: false,
        loadFailText: LOAD_FAIL_CONTENT,
        checkedPassengersForChange: [],
        showStayInfo: false,
        selectSeatType: [],
        isSilent: false,
        meetingTime: '',
        licenseAgreementSelected: false,
        licenseCheckedDefault: false,
        phoneNum: '',
        phoneCheckDesc: '',
        // trainInfo: null,
        stayInfo: null,
        currentPassengerList: [],
        curPassengerIndexList: [],
        orderBaseData: null,
        contactInfo: null,
        reminders: null,
        purchaseList: [],
        isDetailShow: false,
        startDateList: [],
        selectDateCurList: [],
        selectSeatCodeList: [], // 抢票选中座席类型数组
        showDeadline: false, // 抢票截止时间显示与否
        selectDeadline: 2, // 抢票截止时间
        scrollTop: 0, // 是否滑动标识
        lastSelectedSeatIndex: 0,
        showticketNotice: false, // 填单购票通知弹窗 提示不在12306服务时段并有免登入口
        showtikcetPrompt: false, // 填单购票提示弹窗 提示乘车人信息不完整并展示名单
        showRightsDescDrawer: false, // 免登权益说明弹窗
        showWorryFreeDescDrawer: false, // 退改无忧说明弹窗
        errorPassengerList: [], // 不完整乘车人名单 提示乘车人信息不完整
        matchPassengers: [], // 匹配的乘车人信息
        checkForBack: 0, // 用于登录后校验 0无需校验 1单纯校验 2校验后下单
        errAccountFlag: false, // 登录账号错误标识
        dateTextShow: {}, //
        errLoginStatusArr: ['7503','7504','7505','7506','7507','7508','7509','231014'], // 需要重新登录
        showTrainInfomation:false,
        groupStatus:0, // 0未命中实验组 1命中 &初始态 2命中&已选择坐席态 3命中&切换坐席态
        showServiceDescription: false,
        time: null,
        linking: true,
        headerMaxDateTime: null,
        headerMinDateTime: null,
        returnPre: true,
        useBlankPage: false,
        blankImageUrl:
          'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png',
        blankContextTitle: '加载失败',
        blankContextSubTitle: LOAD_FAIL_CONTENT,
        hasButton: false,
        hasRightsChoosed: false, // 购票流程权益卡片是否选择,
      }
    },
    watch:{
      groupStatus:{
        handler(val, old) {
          if (old===1  && val===2) {
            if(!this.currentPassengerList.length){
              this.setDefaultPassenger()
              this.$refs?.transferCard?.hideDetail && this.$refs?.transferCard?.hideDetail()
            }
          }
        }
      },
      selectDate: {
        immediate: true,
        deep: true,
        handler(val) {
          if (!this.time) {
            this.timeChange(val)
          }
        }
      },
      is12306Login:{
        handler(val, old) {
           if (old===0  && val===1 && !this.isTransfer && [2,3].includes(this.groupStatus)) {
            this.getTrainDetailFunc({refreshType:'coupon'})
           }
        }
      }
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo', // 选择的车次坐席数据集
        changeOrderInfo: 'change.changeOrderInfo', // 改签流程数据集,
        scrambleChooseTrains: 'train.scrambleChooseTrains', // 抢票选中车次信息
        token: 'user.token',
        is12306Login: 'login12306.is12306Login',// 是否已登录12306
        userGroup:'common.userGroup', //是否命中实验灰度  0未命中 1已命中
        trainInfo: 'train.trainInfo',
        isTransfer: 'train.isTransfer',
        expectTicket: 'train.expectTicket',
        packageInfo: 'train.packageInfo',
        ticketData: 'train.ticketData',
        makeOrderInfo: 'train.makeOrderInfo',
        selectRightInfo: 'train.selectRightInfo',
        selectRightInfoType: 'train.selectRightInfoType',
        requestForMakeOrderBack: 'common.requestForMakeOrderBack', // 抢票返回重新请求加速包数据
        resetSelectSeatForRecommendBack: 'common.resetSelectSeatForRecommendBack', // 多买少买返回重置选择坐席
        showLoginDrawer: 'login12306.showLoginDrawer',
        selectPackage: 'train.selectPackage',
        showNormalRetentionDrawer: 'makeOrder.showNormalRetentionDrawer',
        showScrambleRetentionDrawer: 'makeOrder.showScrambleRetentionDrawer',
        addedServiceSource: 'makeOrder.addedServiceSource',
      }),
      ...store.mapGetters({
        isExemption: 'makeOrder.isExemption',
        limitDate: 'change.limitDate', // 限制时间
        rightCouponInfo: 'makeOrder.rightCouponInfo',
      }),
      trackParams() {
        const type = this.fromChangeTicket ? 'modify' : 'order'
        return { type }
      },
      maxDateTime() {
        const _max = this.fromChangeTicket
          ? this.limitDate?.maxDate
          : this.limitDate?.maxDateForReserve
        return new Date(_max).getTime()
      },
      minDateTime() {
        return new Date(this.limitDate?.minDate).getTime()
      },
      mainStyle(){
       if(this.isRecommendTicket) return{}
       if (!this.isFromScramble && this.groupStatus ===1){
        return {
          opacity: 0,
          "z-index":"-1",
          display: 'none',
          transition: "opacity 0.5s",
        }
       }
       if (!this.isFromScramble && this.groupStatus ===2){
        return {
          opacity: 1,
          transition: "opacity 0.5s 0.1s",
        }
       }
      },
      footStyle(){
       if(this.isRecommendTicket) return{}
       if (!this.isFromScramble && this.groupStatus ===1){
        return {
          opacity: 0,
          "z-index":"-1",
          display: 'none',
          transition: "opacity 0.5s",
        }
       }
      },
      isStudent() {
        const STUDENT_CODE = 13
        const { passenger_type } = getStorage(STORAGE_LIST_SEARCH_QUERY)
        return +passenger_type === STUDENT_CODE
      },
      isPreScramble(){
        return this.trainInfo?.pre_scrambl_flag === 1
      },
      trackEventPublicParams() {
        return {
          type: this.fromChangeTicket ?
           this.changeTicketType ? 'transitchanges' : 'modify' : 
           this.isFromScramble ? 'snatch' : 
           this.isTransfer ? 'transit' : 'order',
          login_type: this.isExemption ? 'quick' : '12306'
        }
      },
      // 是否是改签流程
      fromChangeTicket() {
        return !!this.changeOrderInfo?.order_id
      },
      // 乘车人列表
      passengersList() {
        return (this.fromChangeTicket ? this.passengersForChange : this.currentPassengerList) || []
      },
      // 乘车人列表总人数
      passengersLength() {
        return this.passengersList.length
      },
      // 乘车人列表学生票人数
      studentLength() {
        // 正常购买passenger_type = 2 或者 ticket_type = 3
        return this.passengersList.filter(item=> (+item.passenger_type === 2 || +item.ticket_type === 3)).length || 0
      },
      // 乘车人列表正常票价人数
      normalPassengerLength() {
        return this.passengersList.filter(item => +item.passenger_type !== 2 && +item.ticket_type !== 3).length || 0
      },
      isFromScramble(){
        const { order_type } = query()
        return order_type === 'scramble'
      },
      isRecommendTicket() {
        const { isRecommend } = query()
        return isRecommend
      },
      customClass() {
        return this.isFromScramble ? '' : 'make-order-custom-class'
      },
      titleBar(){
        let title = this.dateTextShow?.dateText
        const selectTime = this.dateTextShow?.timeStamp
        if(isToday(selectTime)) {
          title += ' 今日出发'
        } else if(isTomorrow(selectTime)) {
          title += ' 明日出发'
        }
        return title
      },
      changeTicketType() {
        // 1中转
        return this.changeOrderInfo?.order_type
      },
      // titlebar 右侧按钮
      sideTitle() {
        return {
          text: this.fromChangeTicket ? '退改须知' : '购票须知',
          jumpFn: () => {
            this.fromChangeTicket
              ? innerRouter.push(pagePath().ICKETPURCHASENOTICE, { checkTabIndex: 'change' })
              : innerRouter.push(pagePath().ICKETPURCHASENOTICE)
          }
        }
      },
      // 车次列表搜索条件
      trainListSearchQuery() {
        return getStorage(STORAGE_LIST_SEARCH_QUERY)
      },
      // 改签时选择的票
      selectTicket() {
        return this.changeOrderInfo?.select_ticket
      },
      // 改签时选择的票所属的订单
      selectOrder() {
        return this.changeOrderInfo?.select_order
      },
      // 改签时选的乘车人
      passengersForChange() {
        // return this.selectOrder?.tickets_info // 多人取订单下的票数据 根据票状态再过滤 TODO
        return JSON.parse(JSON.stringify(this.selectTicket))
      },
      // 是否支持选择坐席
      isSupportChooseSeats() {
        return (
          this.passengersLength <= 5 && 
          this.makeOrderInfo?.is_support_choose_seats?.some(item=>!!item) &&
          !['0',...SLEEPER_SEAT_TYPE]?.some(item => this.selectSeatInfo?.includes(seat=> seat.seat_type === item))
        ) // 非卧铺才可以
      },
      // 正常流程取ticket_price 免登取highest_ticket_price 中转来两程坐席相加
      realTicketPayPrice() {
        if(this.isTransfer) {
          const price = this.selectSeatInfo?.reduce((pre, cur) =>
            pre + (this.isExemption ? Number(cur?.highest_ticket_price || cur?.origin_ticket_price || cur?.ticket_price || 0) : Number(cur?.origin_ticket_price || cur?.ticket_price || 0)), 0)
          return price
        }
        else {
          const { origin_ticket_price, ticket_price, highest_ticket_price } = this.selectSeatInfo[0] || {}
            return this.isFromScramble
              ? this.highestTickPrice
              : this.isExemption && highest_ticket_price
                ? highest_ticket_price
                : origin_ticket_price || ticket_price
        }
      },
      // 是否是夜间购票
      isTicketPeriod() {
        return this.trainInfo?.is_ticket_period === 1
      },
      isShowOriginPrice() {
        const { isRecommend } = query()
        const showOrigin = this.isTicketPeriod || this.isFromScramble || !this.is12306Login || Boolean(isRecommend)
        return showOrigin
      },
      // 正常流程取学生票的价格, 退改无忧:2，便捷购票：1，普通订票：3
      realTicketStudent() {
        if(this.isTransfer) {
          const price = this.selectSeatInfo?.reduce((pre, cur) => {
            return pre + (this.isShowOriginPrice ? Number(cur?.origin_ticket_price || cur?.ticket_price) : Number(cur?.student_ticket_price || cur?.highest_ticket_price))
          }, 0)
          return price
        }
        else {
          // isExemption免登录, 12306未登录展示成人票价, 抢票和夜间购票展示原价
          const { student_ticket_price, highest_ticket_price, ticket_price } = this.selectSeatInfo[0] || {}
          return this.isShowOriginPrice
            ? this.realTicketPayPrice
            : student_ticket_price
        }
      },
      realoriginTicketPrice() {
        if(this.isTransfer) {
          const price = this.selectSeatInfo?.reduce((pre, cur) =>
          pre + Number(cur?.origin_ticket_price))
          return price
        }
        else {
          // isExemption免登录, isFromScramble抢票
          const { origin_ticket_price } = this.selectSeatInfo[0] || {}
          return origin_ticket_price
        }
      },
      // 车票类型 二等座 非中转
      ticketType() {
        const seat_type_name = this.selectSeatInfo[0]?.seat_type_name ? `${this.selectSeatInfo[0]?.seat_type_name} ` : ''
        return seat_type_name
      },
      // 车票价格  ¥ 576 非中转
      ticketPrice() {
        const price = `¥ ${getFinalPrice(this.realTicketPayPrice) || 0}`
        return price
      },
      offlineHandingFee() {
        return getFinalPrice(this.selectRightInfo?.reduce((total,item)=>{
          return total + Number(item?.fee || 0)
        },0) ?? 0)
      },
      // 所选城市对
      selectCityList() {
        return getStorage(STORAGE_CURRENT_SELECTED_CITY)
      },
      passengerAddText() {
        return this.isExemption ? '添加乘车人' :'添加乘车人（成人/学生/儿童)'
      },
      offlineAmount() {
        const amount = this.isTransfer
          ? this.selectSeatInfo[0]?.union_all_type_channels_coupon?.offline?.[this.curTransferIndex]
              ?.deduction_amount
          : this.selectSeatInfo?.[0]?.all_type_channels_coupon?.offline?.deduction_amount
        return amount ?? 0
      },
      login12306Amount() {
        return this.isTransfer
          ? this.selectSeatInfo[0]?.union_all_type_channels_coupon?.login12306?.[
              this.curTransferIndex
            ]?.deduction_amount
          : this.selectSeatInfo?.[0]?.all_type_channels_coupon?.login12306?.deduction_amount
      },
      curTransferIndex() {
        return this.ticketData?.[1]?.findIndex(ticket => ticket.seat_type_name === this.selectSeatInfo?.[1]?.seat_type_name) ?? 0
      },
      //按钮总价数据
      totalFeeInfo() {
        const ticket_price = getFinalPrice(this.realTicketPayPrice) || 0
        let service_price = this.offlineHandingFee || 0
        let student_ticket_price = getFinalPrice(this.realTicketStudent) || 0
        // 便携服务费+车票钱 *人数
        let pay_price = (
          (student_ticket_price + service_price) *
          this.studentLength + (ticket_price + service_price) *
          this.normalPassengerLength
        ).toString()
        // 抢票勾选了正常车次，以价高的展示
        // if (this.isFromScramble && this.studentLength > 0) {
        //   pay_price = (ticket_price > student_ticket_price ? ticket_price : student_ticket_price) *
        //   this.passengersLength
        // }
        // 减去优惠券的价格
        const normalPrice = Number(pay_price) && (Number(pay_price) - Number((this.rightCouponInfo.amount ?? 0) / 100).toFixed(10))
        const _totalFeeInfo = {
          pay_style: 'color: #FF6400',
          pay_price: normalPrice <= 0 ? 0 : normalPrice, // 支付价格 = 原价 - 优惠券
          discount_desc: this.rightCouponInfo.desc,
          coupon_after_price: pay_price // 原价（包含服务费）
        }
        return [_totalFeeInfo]
      },
      // 按钮置灰
      canPay() {
        return !!this.passengersLength
      },
      // 费用明细弹窗数据
      priceDetail() {
        const ticket_types = {}
        const TICKET_TYPE = {
          '1': '成人票',
          '2': '儿童票',
          '3': '学生票',
          '4': '残军票',
        }
        if(this.fromChangeTicket) { // 改签 1成人 2儿童 3学生 4残军
          this.passengersForChange.forEach(({ticket_type}) => {
            const _k = TICKET_TYPE[ticket_type]
            ticket_types[_k] = ticket_types[_k] ? ticket_types[_k] + 1 : 1
          })
        }else{ // 预订 0成人 1儿童 2学生 3残军
          this.currentPassengerList.forEach(({passenger_type}) => {
            const _k = TICKET_TYPE[passenger_type+1]
            ticket_types[_k] = ticket_types[_k] ? ticket_types[_k] + 1 : 1
          })
        }
        let passengerNum = this.passengersLength || 0
        const from_station_name = this.trainInfo?.from_station_name || ''
        const to_station_name = this.trainInfo?.to_station_name || ''
        const ticket_price = getFinalPrice(this.realTicketPayPrice) || 0
        const student_ticket_price = getFinalPrice(this.realTicketStudent) || 0
        // 抢票、夜间购票和免登录购票未登录1206
        const service_price = this.offlineHandingFee || 0
        const seat_type_name = this.isFromScramble
          ? this.selectTrainSeatList[this.selectTrainSeatList?.length - 1]
              ?.seat_name
          : this.selectSeatInfo[0]?.seat_type_name
          ? `${this.selectSeatInfo[0]?.seat_type_name} `
          : ''
        // 12306权益或兜底为空 不展示服务费模块
        const noServiceFee =
         this.selectRightInfo?.every((item) => {
           return Object.keys(item).length === 0 || (item && item.type === 3)
         }) ?? true
        const service_fee_item = noServiceFee
          ? []
          : this.selectRightInfo?.map((item, index) => {
              return {   
                name: `${item.title}服务费`,
                value: `\¥ ${getFinalPrice(item.fee).toFixed(1)} x ${passengerNum}人`,
                bold: true,
                pixel: '14px',
                color: '#666',
              }
            }) ?? []

        const seat_type_items = Object.entries(ticket_types).map(([k, v]) => {
          return {
            name: `${seat_type_name}(${k})`,
            value: `\¥ ${ (k === '学生票' && !this.isShowOriginPrice) ? student_ticket_price : ticket_price.toFixed(1)} x ${v}人`,
            bold: true,
            pixel: '14px',
            color: '#666',
            type: `${k}`,
          }
        })
        const fee_item = [
          {
            name: `${from_station_name} - ${to_station_name}`,
            value: '',
            bold: true,
            pixel: '15px',
            color: '#333333',
          },
          ...seat_type_items,
        ]
        service_fee_item[0] &&
          fee_item.push(service_fee_item[0])
        const transferFeeItem = this.trainInfo?.transfer_ticket?.map((item,index)=>{
          const _price = this.isExemption? this.selectSeatInfo[index]?.highest_ticket_price : (this.selectSeatInfo[index]?.origin_ticket_price || this.selectSeatInfo[index]?.ticket_price)
          const price = getFinalPrice(_price ?? 0) ?? 0
          const seat_type_name = this.selectSeatInfo[index]?.seat_type_name
          const _student_price = this.selectSeatInfo[index]?.student_ticket_price
          const student_price = getFinalPrice(_student_price ?? 0) ?? 0
          const seat_type_items = Object.entries(ticket_types).map(([k, v]) => {
            return {
              name: `${seat_type_name}(${k})`,
              value: `\¥ ${k === '学生票' && !this.isShowOriginPrice ? student_price.toFixed(1) : price.toFixed(1)} x ${v}人`,
              bold: true,
              pixel: '14px',
              color: '#666',
              type: `${k}`,
            }
          })
          const fee_item = [
            {
              name: `${item.from_station_name} - ${item.to_station_name}`,
              value: '',
              bold: true,
              pixel: '15px',
              color: '#333333',
            },
            ...seat_type_items
          ]
          service_fee_item?.[index] &&
            fee_item.push(service_fee_item[index])
          return {
            fee_item
          }
        }) ?? []
        const discount_info = !this.rightCouponInfo.amount
          ? []
          : [
              {
                icon: 'https://ut-static.udache.com/webx/sfc/Zl95rtzA5tcODRp0ilE5S_woshiquan.png',
                name: this.rightCouponInfo.name,
                value: `-¥${this.rightCouponInfo.amount / 100}`,
                valueColor: '#ff4343',
                bold: true,
                pixel: '14px',
                color: '#333',
              }
            ]
        const fee_info = this.isTransfer ? [
          transferFeeItem?.[0] ?? {},
          transferFeeItem?.[1] ?? {},
          {},
          {
            fee_item: discount_info
          }
        ] : [
          {
            fee_item
          },
          {
            fee_item: discount_info
          }
        ]
        return { fee_info }
      },
      // 免登录购票如果有学生票需要展示明细提示
      hasStudent() {
        // 旅客类型 0成人 1儿童 2学生 3残军
        return this.currentPassengerList.find(({passenger_type}) => passenger_type === 2) ? 1 : 0
      },
      // 免登下单 且 卧铺
      priceDetailCardTip() {
        if(!this.selectSeatInfo || !this.selectSeatInfo?.length) return ''
        if(this.isFromScramble) return '按所选坐席中最高金额收取，出票后返还差价'
        const isSleeperType = SLEEPER_SEAT_TYPE.some(item => this.selectSeatInfo.some(seat=> seat.seat_type === item))  ? 1 : 0
        if(!this.isExemption) return ''
        return FEE_DETAIL_TIPS[`${isSleeperType},${this.hasStudent}`]
      },
      startDate() {
        return this.curTrainInfo?.start_time?.split(' ')[0] || ''
      },
      // 当前车次日期索引
      curDateIndex() {
        return this.startDateList?.indexOf(this.startDate)
      },
      // 抢票选中日期信息 原日期通过索引过滤
      selectDateList() {
        const _selectDateList = this.startDateList?.filter(
          (_,index) => this.selectDateCurList.includes(index)
        )
        return _selectDateList
      },
      // 当前车次
      curTrainInfo() {
        return getStorage(STORAGE_DETAIL_SEARCH_QUERY)
      },
      // 当前车次code
      currentTrainCode() {
        const { train_code } = getStorage(STORAGE_DETAIL_SEARCH_QUERY)
        return train_code
      },
      // 通过选中车次获取车次code
      trainCodeList() {
        const _trainCodeList = this.scrambleChooseTrains?.map(
          item => item.train_code
        ).filter(item => item !== this.currentTrainCode)
        return _trainCodeList
      },
      // 通过选中车次数组过滤并排序获取展示座席信息
      trainSeatList() {
        const tempArr = []
        this.scrambleChooseTrains?.forEach(item => {
          if (item.ticket_data?.length) {
            for (const ticket of item.ticket_data) {
              tempArr.push({
                seat_code: ticket.seat_type,
                seat_name: ticket.seat_type_name,
                ticket_price: ticket.ticket_price,
                highest_ticket_price: ticket.highest_ticket_price,
              })
            }
          }
        })
        const resultMap = tempArr?.reduce((acc, item) => {
          if (
            !acc[item.seat_name] ||
            item.highest_ticket_price > acc[item.seat_name].highest_ticket_price
          ) {
            acc[item.seat_name] = item
          }
          return acc
        }, {})
        const _trainSeatList = Object.values(resultMap).sort(
          (a, b) =>
            a.highest_ticket_price - b.highest_ticket_price ||
            a.ticket_price - b.ticket_price
        )
        return _trainSeatList
      },
      highestTickPrice() {
        return (
          this.selectTrainSeatList[this.selectTrainSeatList?.length - 1]
            ?.highest_ticket_price || 0
        )
      },
      selectTrainSeatList() {
        return this.trainSeatList?.filter(item =>
          this.selectSeatCodeList?.includes(item.seat_name)
        )
      },
      scrableSuccessRate() {
        let totalNum =
          this.selectDateCurList?.length +
            this.scrambleChooseTrains?.length -
            2 || 0
        if (totalNum < 1) return 'low'
        totalNum += this.selectSeatCodeList?.length - 1 || 0
        if (totalNum < 2) return 'low'
        else if (totalNum < 4) return 'middle'
        else return 'high'
      },
      passengerAddIcon() {
        return this.isFromScramble
          ? 'https://img-hxy021.didistatic.com/static/starimg/img/FUV9CXTuSu1692471279218.png'
          : 'https://ut-static.udache.com/webx/sfc/VP7okVpXYgPwuxT8q0hh8.webp'
      },
      latestTrainStartTime() {
        return this.scrambleChooseTrains?.length ? this.scrambleChooseTrains?.reduce((max, cur) => {
          return new Date(max.start_time) > new Date(cur.start_time) ? max : cur
        }).start_time : ''
      },
      scrambleNavBar() {
        let _class = ''
        if(this.loadInitDataFail) return _class
        if(!this.isFromScramble) _class += 'white-navbar'
        if(this.isFromScramble) _class += 'scramble-navbar'
        if(this.isFromScramble && this.scrollTop > 1) _class += ' white-navbar'
        return _class
      },
      scrambleFillBox() {
        let _class = ''
        if(this.loadInitDataFail) return _class
        if(!this.isFromScramble) _class += 'white-fillbox'
        if(this.isFromScramble && this.scrollTop > 1) _class += 'white-fillbox'
        return _class
      },
      passengerSource() {
        // 免登或未登录拉本地乘车人列表
        let _passengerSource = 0
        if(this.isExemption === 1 || !this.is12306Login) _passengerSource = 1
        return _passengerSource
      },
      drawerPrice() {
        // todo不知道为什么写了这个，现在用不到了，确定以后可删
        const ticket_price = getFinalPrice(this.realTicketPayPrice) || 0
        let service_price = getFinalPrice(this.selectSeatInfo[0]?.offline_handing_fee) || 0
        if(this.isTransfer) service_price *= this.selectSeatInfo?.length ?? 1
        // 便携服务费+车票钱 *人数
        const pay_price = (
          (ticket_price + service_price) *
          this.passengersLength
        ).toString()
        const exemptionPrice = Number(pay_price ?? 0)
        const normalPrice = Number(pay_price) &&  Number((Number(pay_price) - Number(this.rightCouponInfo.amount ?? 0) / 100).toFixed(10))
        return normalPrice
      },
      stayInfoList() {
        const list = this.trainInfo?.transfer_ticket?.map(item=>{
          return {
            train_date: formatDate(item?.start_time),
            train_code: item?.train_code || '',
            train_no: item?.train_no || '',
            from_station_name: item?.from_station_name || '',
            to_station_name: item?.to_station_name || '',
          }
        })
        return list || []
      },
      dateCardDisabled() {
        return Boolean(this.isTransfer || this.isRecommendTicket)
      },
      // 选择权益后无法重新选择坐席，故展示对应坐席
      hasSelectedSeatPrice() {
        return this.selectSeatInfo?.map((item,index)=>{
          return item && item?.seat_type_name ? 
            `${this.isTransfer ? `第${index+1}程 ` : ''}${item.seat_type_name} ¥${getFinalPrice(item.ticket_price)}` 
            : ''
        }).join("  ")
      },
      // 已选择权益条信息 展示除12306以外的权益服务信息
      showRightsDescBar() {
        return this.selectRightInfo?.every(item=> item && item.type !== 3) ?? false
      },
      // 选择了便携购票服务
      hasSelectExemptionService() {
        return this.selectRightInfo?.every(item=> item && item.type === 1) ?? false
      },
      // 非基础12306与便携购票的增值服务 如退改无忧
      valueAddedServices() {
        return this.selectRightInfo?.every(item=> item && item.type !== 3 && item.type !== 1) ?? false
      },
      // 坐席页选择了普通预定
      regularService() {
        return this.selectRightInfoType === 3
      },
    },
    methods: {
      ...store.mapActions({
        getCurrentUserReverse: 'login12306.getCurrentUserReverse',
        quietAction: 'login12306.quietAction',
        getTrainDetail: 'train.getTrainDetail',
        checkNormalTicketRetentionPopup: 'makeOrder.checkNormalTicketRetentionPopup',
        checkScrambleTicketRetentionPopup: 'makeOrder.checkScrambleTicketRetentionPopup'
      }),
      ...store.mapMutations({
        setChangeOrderInfo: 'change.setChangeOrderInfo',
        setContactSelected: 'newContacts.setContactSelected',
        setIs12306Login: 'login12306.setIs12306Login',
        setScrambleChooseTrains: 'train.setScrambleChooseTrains',
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
        setTravelDate: 'travel.setTravelDate',
        setShowRecommendTickets: 'train.setShowRecommendTickets',
        setRequestForMakeOrderBack: 'common.setRequestForMakeOrderBack',
        setSelectRightInfo: 'train.setSelectRightInfo',
        setResetSelectSeatForRecommendBack: 'common.setResetSelectSeatForRecommendBack',
        setSelectSeatInfo: 'train.setSelectSeatInfo',
        setShowLoginDrawer: 'login12306.setShowLoginDrawer',
        setMakeOrderBaseInfo: 'makeOrder.setMakeOrderBaseInfo',
      }),
      dateCardClickReport(params) {
        const module = params?.detail
        trackEvent('userteam_train_trainnum_date_ck', 'UT-火车票-车次详情-日期模块-点击', {
          ...this.trackParams,
          module
        })
      },
      timeChange(val) {
        this.time = [val]

        const flag1 = this.maxDateTime - val < 604800000
        this.headerMaxDateTime = flag1 ? this.maxDateTime : ''
        const flag2 = val - this.minDateTime < 604800000
        this.headerMinDateTime = flag2 ? this.minDateTime : ''
      },
      changeDate(data) {
        const date = new Date(data?.[0]).setHours(8)
        // 车次列表搜索参数更新
        let searchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY)
        const compareTime = compare(getDayByOffset(Date.now(), 59).getTime(), date)
        if (compareTime >= 0) {
          if (
            formatDateShare(date, 'YYYY-MM-dd') !== searchQuery?.train_date &&
            date <= this.maxDateTime &&
            date >= this.minDateTime
          ) {
            // 选中日期保存更新
            this.setTravelDate(date)
            searchQuery = {
              ...searchQuery,
              train_date: formatDateShare(date, 'YYYY-MM-dd')
            }
            setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: searchQuery })

            this.getTrainDetailFunc()
          }
        } else {
          Toast({
            message: '您所选择的日期列车暂未开售，请选择其他日期',
            overlay: false
          })
          if (this.returnPre) {
            this.$refs?.__mpx_ref_date_card__?.returnToPre?.() // 小程序
            this.$refs?.date_card?.returnToPre?.() // h5
          } else {
            this.$refs?.__mpx_ref_date_card__?.returnToPre?.() // 小程序
            this.$refs?.date_card?.returnToPre?.() // h5
            this.linking = false
            setTimeout(() => {
              this.linking = true
            }, 500)
          }
        }
        this.resetSeatRights()
        this.returnPre = true
      },
      async handleClickDay(data) {
        this.changeDate.call(this, data.detail.data)
      },
      onConfirm(data) {
        this.returnPre = false
        this.changeDate.call(this, data.detail)
      },
      goBackReport() {
        trackEvent('userteam_train_conorder_return_ck', 'UT-火车票-确认订单页-返回-点击', {
          ...this.trackEventPublicParams
        })
      },
      // 初始化
      async init() {
        this.initData()
        !this.isFromScramble
          && !this.fromChangeTicket && (await this.fetchUserState())
        // 抢票一定要是登录态，有问题请求列表时候提示
        this.isFromScramble && this.setIs12306Login(1)
        this.loadOrderBaseInfo()
        this.setContactSelected([])
      },
      async initData() {
        await this.getTrainDetailFunc()
        this.setDefaultPassenger()
           // 车次信息
        const { makeOrderInfo, trainInfo } = getStorage(STORAGE_TRAIN_INFO)
        // this.makeOrderInfo = makeOrderInfo
        // this.trainInfo = trainInfo
        this.meetingTime = this.trainListSearchQuery?.train_date
      },
      trainDetailParams() {
        const { train_date, booking_type, start_time_list } = getStorage(STORAGE_LIST_SEARCH_QUERY)
        const { train_no, train_code,  transfer_ticket, transfer_stop_time, transfer_station_city_name } = getStorage(
          STORAGE_DETAIL_SEARCH_QUERY
        )
        const { from_station_name, to_station_name } = this.isRecommendTicket ? this.trainInfo : getStorage(STORAGE_DETAIL_SEARCH_QUERY)
        const userGroup = this.userGroup ?? false
        const from_city_id = this.selectCityList?.[0]?.id
        const to_city_id = this.selectCityList?.[1]?.id
        const startTime = JSON.parse(start_time_list)[0] || '00:00:00'
        const start_date_time = train_date + ' ' + startTime
        //改签为1 下单为0
        const is_change_ticket = this.fromChangeTicket ? 1 : 0
        const { passenger_type } = getStorage(STORAGE_LIST_SEARCH_QUERY)
        const union_type = (this.isTransfer && !this.fromChangeTicket)  ? 1 : 0
        const train_nos = JSON.stringify(transfer_ticket?.map(item => item.train_no) ?? [])
        const train_codes = JSON.stringify(transfer_ticket?.map(item => item.train_code) ?? [])
        const from_station_names = JSON.stringify(transfer_ticket?.map(item => item.from_station_name) ?? [])
        const to_station_names = JSON.stringify(transfer_ticket?.map(item => item.to_station_name) ?? [])
        const from_station_nos = JSON.stringify(transfer_ticket?.map(item => item.from_station_no) ?? [])
        const to_station_nos = JSON.stringify(transfer_ticket?.map(item => item.to_station_no) ?? [])
        const train_secrets = JSON.stringify(transfer_ticket?.map(item => item.train_secrets) ?? [])
        const params = {
          start_time: start_date_time,
          from_station_name,
          to_station_name,
          train_no,
          train_code,
          from_city_id,
          to_city_id,
          booking_type,
          is_change_ticket,
          passenger_type,
          union_type,
          train_nos,
          train_codes,
          from_station_names,
          to_station_names,
          from_station_nos,
          to_station_nos,
          train_secrets,
          transfer_stop_time,
          transfer_station_city_name,
          userGroup,
          noNeedStorage: this.isRecommendTicket ? true : false,
          recommend: this.isRecommendTicket ? 1 : 0,
        }
        trackEvent('', '排查--填单--trainDetailParams--参数上报', params)
        return params
      },
      /**
       * @method 获取车次详情
      */
      getTrainDetailFunc(option={}) {
        const { refreshType } = option
        if(!this.userGroup) {
          return this.showTrainInfomation = true
        }else{
          if(this.isFromScramble){
            this.showTrainInfomation = true
            this.groupStatus = 1
            return
          }
          if(refreshType !== 'coupon'){
            this.groupStatus = 1
            this.showTrainInfomation= false
            this.useBlankPage = false
          }
          return new Promise((resolve, reject) => {
            this.getTrainDetail({...this.trainDetailParams(),...option})
              .then((res) => {
                mpx.hideLoading()
                resolve()
                const { code, data, message, success } = res || {}
                if (success) {
                  this.showTrainInfomation = true
                  if (
                    code === '0' &&
                    data?.from_station_name &&
                    data?.to_station_name
                  ) {
                    this.useBlankPage = false
                    this.blankImageUrl = null
                    this.blankContextTitle = ''
                    this.blankContextSubTitle = ''
                    this.hasButton = false
                  } else {
                    this.useBlankPage = true
                    this.blankImageUrl =
                      'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
                    this.blankContextTitle = '当天没有该车次'
                    this.blankContextSubTitle = '换个时间再试试'
                    this.hasButton = false
                    trackEvent('userteam_train_trainnum_noresult_sw', 'UT-火车票-首页-车次详情无结果-曝光', this.trackParams)
                  }
                } else {
                  this.useBlankPage = true
                  this.blankImageUrl =
                    'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
                  this.blankContextTitle = '加载失败'
                  this.blankContextSubTitle = LOAD_FAIL_CONTENT
                  this.hasButton = true
                  Toast({
                    message: '车票查询失败',
                    overlay: false,
                    duration: 3000
                  })
                  return
                }
              })
              .catch((e) => {
                mpx.hideLoading()
                console.log('error', e)
              })
              .finally(() => {
                mpx.hideLoading()
              })
          })
        }
      },
      seatInfoClickReport(params) {
        const item = params?.detail
        const { seat_type_name , ticket_num } = item || {}
        const scrambleFlag = this.selectSeatInfo.some(item=> item.ticket_num === '无票' || !item.ticket_num)
        if(this.trainInfo?.is_ticket_period && this.userGroup){
          this.setMakeOrderLoginType(1)
        }
        // else{
        //   this.setMakeOrderLoginType(0)
        // }
        if(this.isPreScramble || scrambleFlag){
          this.groupStatus = 1
        }else {
          this.groupStatus = 2
          // 通过点击状态变化完成侧面反应曝光
          trackEvent('userteam_train_conorder_sw', 'UT-火车票-车次详情-确认订单页-曝光', {
            ...this.trackEventPublicParams
          })
        }
        trackEvent('userteam_train_trainnum_order_ck', 'UT-火车票-确认订单页-预定/抢票-点击', {
          type: this.fromChangeTicket ? 'modify' :(scrambleFlag || this.isPreScramble)  ? 'snatch' : 'order',
          seat_type_name
        })
      },
      getSeatLength(item) {
        let length = 0
        const seat_type_map = {
          9: 3,
          P: 3,
          M: 4,
          O: 5
        }
        return seat_type_map[item?.seat_type] || 0
      },
      // baseMakeOrderInfo
      loadOrderBaseInfo() {
        getOrderBaseInfo({
          order_type: this.isExemption,
          start_date: this.startDate
        })
          .then(({ data, success, code, message }) => {
            if (success && code === '0') {
              this.loadInitDataFail = false
              this.orderBaseData = data
              this.reminders = data?.reminders
              this.purchaseList = (data?.reminders?.purchase_note || []).concat((data?.reminders?.privacy_protocol || []))
              this.contactInfo = data?.contact
              this.phoneNum = AES_ECB_DECRYPT(this.contactInfo?.contact_phone)
              this.startDateList = data?.scramble_ticket_order?.select_date || []
              this.setMakeOrderBaseInfo(data)
              this.selectDateCurList?.push(this.curDateIndex)
               this.getTrainCheckedProtocol()
            } else {
              this.loadInitDataFail = true
              this.loadFailText = !success ? LOAD_FAIL_CONTENT : message || LOAD_FAIL_CONTENT
            }
          })
          .catch((e) => {})
          .finally(() => {
            mpx.hideLoading()
          })
      },
      // 勾选协议
      licenseClick() {
        this.licenseAgreementSelected = !this.licenseAgreementSelected
      },
      jumpToH5(item, index) {
        if (item.name === '铁路互联网购票须知') {
          innerRouter.push(pagePath().ICKETPURCHASENOTICE)
        } else {
          innerRouter.goTo(item.url)
        }
      },
      rememberTrainCheckedProtocol(){
        const checked_protocol = this.purchaseList.map((item) => item.key).reduce((pre, cur) => {
          pre[cur] = true
          return pre
        } , {});
        const params = { checked_protocol }
        rememberTrainCheckedProtocol(params)
      },
      getTrainCheckedProtocol(){
        const key_list = this.purchaseList.map((item) => item.key)
        getTrainCheckedProtocol({
          key_list_str: JSON.stringify(key_list)
        }).then(res => {
          const { data, code, success, message } = res || {}
          if(!data?.need_check) {
            this.licenseAgreementSelected = this.licenseCheckedDefault = true
          }
        })
      },
      // 跳转协议页面
      jumpToLicense(item, index) {
        Dialog.close()
        if (item.name === '铁路互联网购票须知') {
          innerRouter.push(pagePath().ICKETPURCHASENOTICE)
        } else {
          innerRouter.goTo(item.url)
        }
      },
      // 未勾选时，点击提交订单按钮弹框提示
      concealConfim() {
        return Dialog.confirm({
          title: '订票服务协议',
          cancelButtonText: '再想想',
          confirmButtonText: '同意并继续',
          selector: '#es-dialog-book',
          confirm: () => {
            this.licenseClick()
            this.beforeSubmitOrder()
          },
          cancel: () => {}
        })
      },
      // 下单数据校验
      submitCheck() {
        var validator = new Validator()

        //坐席 要么不选 要么就要与人数相等
        validator.add(
          this.curPassengerIndexList?.length !== 0 &&
            this.selectSeatType?.some(item => item && item.length !== this.curPassengerIndexList?.length
              && item.length !== 0) &&
            !this.fromChangeTicket,
          '需要为每一位乘客选座哦'
        )

        validator.add(
          (!this.curPassengerIndexList?.length && !this.fromChangeTicket) ||
            (!this.checkedPassengersForChange?.length && this.fromChangeTicket),
          '请添加乘车人'
        )

        validator.add(!this.selectSeatInfo, '请选择座位')

        if (!this.fromChangeTicket) {
          this.phoneCheckDesc = ''
          const checkPhoneNumberRules = [
            [this.phoneNum?.trim().length == 0, '请输入乘车人手机号'],
            [!MOBILE_CHECK_REG.test(this.phoneNum?.trim()), '请输入正确格式的手机号']
          ]
          checkPhoneNumberRules.forEach(([rule, msg]) => {
            if (rule) {
              this.phoneCheckDesc = msg
            }
            validator.add(rule, msg)
          })
        }

        const errorMsg = validator.start()
        if (errorMsg) {
          mpx.showToast({
            title: errorMsg,
            icon: 'error'
          })
          return true
        }
        return false
      },
      // 下单前校验
      async beforeSubmitOrder(needRetention = true) {
        this.isDetailShow = false
        if (isFastDoubleClick() || this.submitCheck()) {
          this.trackSubmit(0)
          return
        }
        // 未勾选时，点击提交订单按钮弹框提示
        if (!this.licenseAgreementSelected && !this.fromChangeTicket) {
          this.trackSubmit(0)
          return this.concealConfim()
        }
        this.rememberTrainCheckedProtocol()

        this.trackSubmit(1)
        if( this.isFromScramble ){
          //抢票订单
          if (
            new Date(this.latestTrainStartTime) - new Date() <
            1800000
          ) {
            return mpx.showToast({
              title: '当前所选车次即将发车，请选择其他车次',
              icon: 'error',
            })
          }
          if(needRetention) {
            const popupFlag = await this.checkScrambleTicketRetentionPopup(this.realTicketPayPrice)
            if(popupFlag) return 
          }
          const __makeOrderParams = this.getMakeScrambleOrderParams()
          this.makeScrambleOrder(__makeOrderParams)
        } else if(this.isTransfer) {
          // 转车订单
          const __makeOrderParams = this.getMakeTransferOrderParams()
          delete __makeOrderParams.added_service_source
          this.makeTransferOrder(__makeOrderParams)
        } else{
          const __makeOrderParams = this.getMakeOrderParams()
          if(this.fromChangeTicket) {
            delete __makeOrderParams.expect_ticket
            delete __makeOrderParams.added_service_source
            this.changeTicket(__makeOrderParams)
          }
          else {
            if(needRetention) {
              const popupFlag = await this.checkNormalTicketRetentionPopup()
              console.log('%c [ popupFlag ]-1622', 'font-size:13px; background:pink; color:#bf2c9f;', popupFlag)
              if(popupFlag) return 
            }
            this.makeOrder(__makeOrderParams)
          }
        }
      },
      trackSubmit(is_success) {
        trackEvent('userteam_train_conorder_submit_ck', 'UT-火车票-确认订单页-提交-点击', {
          is_success,
          ...this.trackEventPublicParams
        })
      },
      getCommonOrderParams(){
        const ticket_price = this.selectSeatInfo[0]?.ticket_price
        const meetingTime = getStorage(STORAGE_LIST_SEARCH_QUERY)?.train_date ?? ''
        return {
          train_no: this.makeOrderInfo?.train_no,
          train_code: this.makeOrderInfo?.train_code,
          train_type_code: this.makeOrderInfo?.train_type_code,
          from_station_name: this.makeOrderInfo?.from_station_name,
          to_station_name: this.makeOrderInfo?.to_station_name,
          from_station_telecode: this.makeOrderInfo?.from_station_telecode,
          to_station_telecode: this.makeOrderInfo?.to_station_telecode,
          start_time: this.makeOrderInfo?.start_time,
          train_secrets: this.makeOrderInfo?.train_secrets,
          from_city_id: this.selectCityList?.[0]?.id,
          to_city_id: this.selectCityList?.[1]?.id,
          seat_type: this.selectSeatInfo[0]?.seat_type,
          seat_name: this.selectSeatInfo[0]?.seat_type_name,
          start_date: meetingTime,
          choose_seats: this.selectSeatType[0]?.join(''),
          ticket_price: ticket_price,
          order_source: ORDER_SOURCE,
        }

      },
      getMakeTransferOrderParams() {
        const { transfer_ticket }  =  this.trainInfo
        const tickets = []
        this.currentPassengerList.forEach((item) => {
          if (this.curPassengerIndexList?.includes(item.id)) {
            this.selectSeatInfo.forEach((seat,index) => {
              const commonParams = {
                special_flag: this.isSilent === true ? 1 : 0, // 是否为静音车厢
                ticket_price: (+item.passenger_type === 2 && !this.isShowOriginPrice) ? seat?.student_ticket_price : seat?.origin_ticket_price, // 车票价格
                origin_ticket_price: seat?.origin_ticket_price // 学生票新增字段
              }
              tickets.push({
                 ...commonParams,
                 traveler_id: item.id, // 出行人id
                 encrypt_passenger_id_no: item.id_no, // 加密身份证号
                 ticket_type: item.passenger_type || 0, // 旅客类型 0成人 1儿童 2学生 3残军
                 passenger_id_type: item.id_type, // id类别
                 passenger_name: item?.passenger_name, // 乘客名字
                 passenger_phone: item.mobile_no, // 乘客手机号（加密
                 born_date: item.born_date, // 加密出生日期
                 sex: item.sex, // 性别
                 country_code: item?.canonical_country_code, // 国籍代码
                 union_segment_index: index + 1,
                 service_fee: this.selectRightInfo?.[index]?.fee,
                 rights: this.selectRightInfo?.[index]?.rights,
               })
            })
          }
        })
        const params = {
          ...this.getMakeOrderParams(),
          transfer_stop_time: this.makeOrderInfo.transfer_stop_time ?? '',
          transfer_station_city_name: this.makeOrderInfo.transfer_station_city_name ?? '',
          train_nos: JSON.stringify(transfer_ticket?.map(item => item?.train_no)),
          train_codes: JSON.stringify(transfer_ticket?.map(item => item?.train_code)),
          seat_types: JSON.stringify(this.selectSeatInfo?.map(item => item?.seat_type)),
          seat_names: JSON.stringify(this.selectSeatInfo?.map(item => item?.seat_type_name)),
          from_station_nos: JSON.stringify(transfer_ticket?.map(item => item?.from_station_no)),
          to_station_nos: JSON.stringify(transfer_ticket?.map(item => item?.to_station_no)),
          train_type_codes: JSON.stringify(transfer_ticket?.map(item => item?.train_type_code)),
          from_station_names: JSON.stringify(transfer_ticket?.map(item => item?.from_station_name)),
          to_station_names: JSON.stringify(transfer_ticket?.map(item => item?.to_station_name)),
          from_station_telecodes: JSON.stringify(transfer_ticket?.map(item => item?.from_station_telecode)),
          to_station_telecodes: JSON.stringify(transfer_ticket?.map(item => item?.to_station_telecode)),
          start_times: JSON.stringify(transfer_ticket?.map(item => item?.start_time?.split(" ")[1]?.slice(0,5))),
          start_dates: JSON.stringify(transfer_ticket?.map(item => item?.start_time?.split(" ")[0])),
          arrive_times: JSON.stringify(transfer_ticket?.map(item => item?.arrive_time?.split(" ")[1]?.slice(0,5))),
          arrive_dates: JSON.stringify(transfer_ticket?.map(item => item?.arrive_time?.split(" ")[0])),
          train_secrets: JSON.stringify(transfer_ticket?.map(item => item?.train_secrets)),
          from_city_ids: JSON.stringify(transfer_ticket?.map(item => item?.from_station_city_id)),
          to_city_ids: JSON.stringify(transfer_ticket?.map(item => item?.to_station_city_id)),
          special_flags: JSON.stringify(transfer_ticket?.map(item => item?.special_flag)),
          choose_seats: JSON.stringify(this.selectSeatType?.map(item => item.join(""))),
          union_type: 1,
          tickets: JSON.stringify(tickets),
        }
        return params
      },
      makeTransferOrder(__makeOrderParams) {
        setStorage({ key: STORAGE_SELECT_TICKET, data: {} })
        makeUnionOrder(__makeOrderParams).then(({ data, code, success, message }) => {
          if (success) {
            if (code === '0' && data?.order_id) {
              // const personalPay = this.highestTickPrice * this.curPassengerIndexList.length
              // this.makePay(data?.order_id,personalPay)
              const { from } = this.$mpxRoute?.query || {}
              // 支付完清除权益信息
              this.setSelectRightInfo([])
              innerRouter.redirect(pagePath().ORDERDETAIL, {
                order_id: data?.order_id,
                from: 'home'
              })
            } else if (code === '7510' || code === '8000') {
              Dialog.confirm({
                title: '温馨提示',
                message: '请登录与下单时一致的12306账号',
                cancelButtonText: '知道了',
                confirmButtonText: '去登录',
                confirm: () => {
                  innerRouter.push(pagePath().LOGIN12306)
                }
              })
            } else {
              this.showRequestErrorToast(message)
            }
          }
        })
      },
      getMakeScrambleOrderParams(){
        // 组装抢票下单参数
        const ticket_price = this.selectSeatInfo[0]?.ticket_price
        const personalPay = this.highestTickPrice * this.curPassengerIndexList.length
        const passengers = []
        this.currentPassengerList.forEach((item) => {
          if (this.curPassengerIndexList?.includes(item.id)) {
            passengers.push({
              special_flag: this.isSilent === true ? 1 : 0, // 是否为静音车厢
              traveler_id: item.id, // 出行人id
              encrypt_passenger_id_no: item.id_no, // 加密身份证号
              ticket_type: item.passenger_type || 0, // 旅客类型 0成人 1儿童 2学生 3残军
              passenger_id_type: item.id_type, // id类别
              passenger_name: item?.passenger_name, // 乘客名字
              passenger_phone: item.mobile_no, // 乘客手机号（加密
              passenger_source: item.passenger_source,
              born_date: item.born_date, // 加密出生日期
              sex: item.sex, // 性别
              country_code: item?.canonical_country_code // 国籍代码
            })
          }
        })
        const scrableSuccessRateMap = {
          'low': '中等',
          'middle': '较高',
          'high': '极高'
        }

        return {
          ...this.getCommonOrderParams(),
          // 抢票参数
          "highest_ticket_price": this.highestTickPrice, //最高票价
          "dead_line_hour": this.selectDeadline,       //截止时间 距离所抢车票中最晚发车时间多久 单位分钟
          "personal_pay": personalPay || 0, //总计费用 该费用为前端根据用户选择的所有车票的最高价格*乘车人数量计算得出
          "total_price": personalPay || 0,
          "contact_phone": AES_ECB_ENCRYPT(this.phoneNum?.trim()),
          "passengers": JSON.stringify(passengers),
          "alternative_train_codes":JSON.stringify(this.trainCodeList),
          "alternative_start_date": JSON.stringify(this.selectDateList),
          "alternative_seat_code":JSON.stringify(this.selectTrainSeatList),
          "success_rate_desc": scrableSuccessRateMap[this.scrableSuccessRate],
          "package":JSON.stringify(this.selectPackage),
          added_service_source: JSON.stringify(this.addedServiceSource), // 埋点数据--添加的附加服务来源
        }
      },
      // 组装下单参数
      getMakeOrderParams() {
        const changeTicket = this.fromChangeTicket

        const ticketData = []
        const ticket_price_show = this.realTicketPayPrice
        const origin_ticket_price = this.realoriginTicketPrice
        const student_ticket_price = this.realTicketStudent || 0
        const commonParams = {
          special_flag: this.isSilent === true ? 1 : 0, // 是否为静音车厢
          // ticket_price, // 车票价格
          origin_ticket_price // 学生票新增
        }
        const seat_types = JSON.stringify(this.selectSeatInfo?.map(item=>item && item.seat_type))
        const seat_names = JSON.stringify(this.selectSeatInfo?.map(item=>item && item.seat_type_name))
        const meetingTime = getStorage(STORAGE_LIST_SEARCH_QUERY)?.train_date ?? ''
        let personalPay // 支付的价格

        if (this.fromChangeTicket) {
          personalPay = ticket_price_show * this.checkedPassengersForChange.length
          this.checkedPassengersForChange.forEach((item) => {
            ticketData.push({
              ...commonParams,
              traveler_id: item.traveler_id, // 出行人id
              old_ticket_id: item.ticket_id,
              ticket_type: item.ticket_type,
              encrypt_passenger_id_no: item.passenger_encrypt_id_no, // 加密身份证号
              passenger_id_type: item.passenger_id_type, // id类别
              born_date: item.born_date, // 加密出生日期
              country_code: item.canonical_country_code, // 国籍代码
              sex: item.sex, // 性别
              passenger_phone: item.passenger_phone, // 乘客手机号（加密
              passenger_name: item.passenger_name, // 乘客名字
              union_segment_index: item.union_segment_index,
              ticket_price: (+item.passenger_type === 2 || +item.ticket_type === 3)? student_ticket_price : ticket_price_show
            })
          })
        } else {
          personalPay = (ticket_price_show + this.offlineHandingFee) * this.curPassengerIndexList.length
          this.currentPassengerList.forEach((item) => {
            if (this.curPassengerIndexList?.includes(item.id)) {
              ticketData.push({
                ...commonParams,
                traveler_id: item.id, // 出行人id
                encrypt_passenger_id_no: item.id_no, // 加密身份证号
                ticket_type: item.passenger_type || 0, // 旅客类型 0成人 1儿童 2学生 3残军
                passenger_id_type: item.id_type, // id类别
                passenger_name: item?.passenger_name, // 乘客名字
                passenger_source: item.passenger_source,
                passenger_phone: item.mobile_no, // 乘客手机号（加密
                born_date: item.born_date, // 加密出生日期
                sex: item.sex, // 性别
                country_code: item?.canonical_country_code, // 国籍代码
                service_fee: this.selectRightInfo?.[0]?.fee,
                rights: this.selectRightInfo?.[0]?.rights,
                ticket_price: +item.passenger_type === 2 ? student_ticket_price : ticket_price_show
              })
            }
          })
        }

        return {
          train_no: this.makeOrderInfo?.train_no,
          train_code: this.makeOrderInfo?.train_code,
          train_type_code: this.makeOrderInfo?.train_type_code,
          from_station_name: this.makeOrderInfo?.from_station_name,
          to_station_name: this.makeOrderInfo?.to_station_name,
          from_station_telecode: this.makeOrderInfo?.from_station_telecode,
          to_station_telecode: this.makeOrderInfo?.to_station_telecode,
          start_time: this.makeOrderInfo?.start_time,
          train_secrets: this.makeOrderInfo?.train_secrets,
          from_city_id: this.selectCityList?.[0]?.id,
          to_city_id: this.selectCityList?.[1]?.id,
          seat_type: this.selectSeatInfo[0]?.seat_type,
          seat_name: this.selectSeatInfo[0]?.seat_type_name,
          start_date: meetingTime,
          choose_seats: this.selectSeatType[0]?.join(''),
          personal_pay: personalPay || 0,
          total_price: personalPay || 0,
          // 改签参数
          order_id: changeTicket ? this.changeOrderInfo?.order_id : '',
          ticket_ids: changeTicket ? JSON.stringify(this.changeOrderInfo?.ticket_id) : '[]',
          sequence_no: this.changeOrderInfo?.supplier_order_id,
          contact_phone: changeTicket
            ? this.changeOrderInfo?.contact_phone
            : AES_ECB_ENCRYPT(this.phoneNum?.trim()),
          tickets: JSON.stringify(ticketData),
          order_source: ORDER_SOURCE,
          order_type: this.isExemption,
          seat_types: seat_types,
          seat_names: seat_names,
          expect_ticket: this.expectTicket?.type ? this.expectTicket : undefined,
          service_scene: this.selectRightInfo?.[0]?.scene,
          service_type: this.selectRightInfo?.[0]?.type,
          added_service_source: JSON.stringify(this.addedServiceSource), // 埋点数据--添加的附加服务来源
        }
      },
      //抢票
      makeScrambleOrder(__makeOrderParams) {
        makeScrambleOrder(__makeOrderParams).then(({ data, code, success, message }) => {
          if (success) {
            if (code === '0' && data?.order_id) {
              this.setRequestForMakeOrderBack(true)
              // const personalPay = this.highestTickPrice * this.curPassengerIndexList.length
              // this.makePay(data?.order_id,personalPay)
              const { from } = this.$mpxRoute?.query || {}
              this.setSelectRightInfo([])
              innerRouter.redirect(pagePath().ORDERDETAIL, {
                order_id: data?.order_id,
                from: 'home'
              })
            } else if (code === '7510' || code === '8000') {
              Dialog.confirm({
                title: '温馨提示',
                message: message || '请登录与下单时一致的12306账号',
                cancelButtonText: '知道了',
                confirmButtonText: '去登录',
                confirm: () => {
                  innerRouter.push(pagePath().LOGIN12306)
                }
              })
            } else if (code === '7512') {
              Dialog.confirm({
                title: '温馨提示',
                message: '价格发生变化，点击刷新',
                cancelButtonText: '取消',
                confirmButtonText: '知道了',
                confirm: () => {
                  this.updateHighestPrice(data.tickets[0])
                }
              })
            } else {
              this.showRequestErrorToast(message)
            }
          }
        })
      },
      // 抢票下单之后付钱
      makePay(order_id,personalPay) {
        makePay({
          order_id: order_id,
          total_fee: personalPay,
          personal_pay: personalPay,
          pre_pay_type:1
        })
          .then(res => {
            const { data, message, code, success } = res || {}
            mpx.hideLoading()
            if (success) {
              if (code === '0' && data != null) {
                const { out_trade_id, reminder } = data
                this.onPayment(out_trade_id, reminder,order_id)
              } else if (code === '7003') {
                this.showRequestErrorToast(message)
                this.init()
              } else {
                this.showRequestErrorToast(message)
              }
            } else {
              this.showRequestErrorToast()
            }
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      onPayment(out_trade_id, reminder,order_id) {
        const { appid } = this.$mpxRoute.query || {}
        if (__mpx_mode__ === 'web') {
          const { token } = this
          const payType = 'payed'
          payMgr
            .pay({
              out_trade_id: out_trade_id,
              token: token,
              yks_appid: appid
            })
            .then((res) => {
              setStorage({
                key: STORAGE_SUCCESS_INFO,
                data: {
                  payType,
                  title: ORDERSTATUSINFO?.[payType]?.title,
                  status: ORDERSTATUSINFO?.[payType]?.status,
                  desc:  ORDERSTATUSINFO?.[payType]?.desc,
                  content: []
                }
              })
              const { from } = this.$mpxRoute?.query || {}
              innerRouter.mpReplace(pagePath().ORDERDETAIL, {
                order_id,
                from,
              })
            })
            .catch((err) => {
              const { from } = this.$mpxRoute?.query || {}
              innerRouter.mpReplace(pagePath().ORDERDETAIL, {
                order_id,
                from,
              })
            })
            .finally(() => {
              mpx.hideLoading()
            })
        }
      },
      showRequestErrorToast(message) {
        mpx.showToast({
          title: message || LOAD_FAIL_CONTENT,
          icon: 'error'
        })
      },
      // 预定
      makeOrder(__makeOrderParams) {
        setStorage({ key: STORAGE_SELECT_TICKET, data: {} })
        makeOrder(__makeOrderParams)
          .then(({ data, code, success, message }) => {
            if (success) {
              if (code === '0' && data?.order_id) {
                const { from } = this.$mpxRoute.query
                this.setSelectRightInfo([])
                innerRouter.redirect(pagePath().ORDERDETAIL, {
                  order_id: data?.order_id,
                  from: 'home',
                })
              } else if (code === '10608') {
                this.quietAction() // 静默登录请求
              } else if (code === '3019') {
                mpx.hideLoading()
                Dialog.confirm({
                  title: '下单提示',
                  message: message ?? '当前车次已预定成功，请您前去支付即可',
                  cancelButtonText: '我知道了',
                  confirmButtonText: '查看订单',
                  confirm: () => {
                    const { from } = this.$mpxRoute.query
                    this.setSelectRightInfo([])
                    innerRouter.redirect(pagePath().ORDERDETAIL, {
                      order_id: data?.order_id,
                      from: 'home'
                    })
                  }
                })
              } else if (code === '3020') {
                mpx.hideLoading()
                Dialog.alert({
                  title: '下单提示',
                  message: message ?? '当前车次已出票成功，请您不要重复下单',
                  confirmButtonText: '我知道了',
                  confirm: () => {
                    console.log('我知道了')
                  },
                  cancel: () => {}
                })
              } else {
                mpx.hideLoading()
                if (code === '10526') {
                  this.openLoginDrawer()
                }
                else if(code === '2015'){
                  this.showticketNotice = true
                }
                else {
                  Dialog.alert({
                    title: '下单失败',
                    message: message ?? '下单失败，请稍后再试',
                    confirmButtonText: '我知道了',
                    confirm: () => {
                    },
                    cancel: () => {}
                  })
                }
              }
            } else {
              mpx.hideLoading()
              mpx.showToast({
                title: LOAD_FAIL_CONTENT,
                icon: 'error'
              })
            }
          })
          .catch((e) => {
            mpx.showToast({
              title: LOAD_FAIL_CONTENT,
              icon: 'error'
            })
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      // 改签
      changeTicket(__makeOrderParams) {
        changeTicketOrder(__makeOrderParams)
          .then(({ data, code, success, message }) => {
            if (success) {
              if (code === '0' && data?.order_id) {
                const order_id = this.changeOrderInfo?.order_id
                this.setChangeOrderInfo({})
                this.setSelectRightInfo([])
                const { from } = this.$mpxRoute.query || {}
                innerRouter.replace(pagePath().ORDERDETAIL, {
                  order_id,
                  from: 'home'
                })
              } else if (code === '10608') {
                this.quietAction() // 静默登录请求
              } else if (code === '9016') {
                Dialog.confirm({
                  title: '温馨提示',
                  message: message || '请登陆与下单时一致的12306账号',
                  cancelButtonText: '知道了',
                  confirmButtonText: '去登录',
                  confirm: () => {
                    innerRouter.push(pagePath().LOGIN12306)
                  }
                })
              } else if (code === '3019') {
                Dialog.confirm({
                  title: '改签提示',
                  message: message ?? '当前有待支付订单，请您先完成支付',
                  cancelButtonText: '我知道了',
                  confirmButtonText: '查看订单',
                  confirm: () => {
                    const { from } = this.$mpxRoute.query || {}
                    innerRouter.replace(pagePath().ORDERDETAIL, {
                      order_id: data?.order_id,
                      from: 'home'
                    })
                  }
                })
              } else if (code === '3020') {
                Dialog.alert({
                  title: '改签提示',
                  message: message ?? '不可改签至相同车次',
                  confirmButtonText: '我知道了',
                  confirm: () => {
                    console.log('我知道了')
                  },
                  cancel: () => {}
                })
              } else if (this.errLoginStatusArr.includes(code)) {
                Dialog.confirm({
                  title: '温馨提示',
                  message: '请登录与下单时一致的12306账号',
                  cancelButtonText: '知道了',
                  confirmButtonText: '去登录',
                  confirm: () => {
                    innerRouter.push(pagePath().LOGIN12306)
                  }
                })
              } else {
                Dialog.alert({
                  title: '改签失败',
                  message: message ?? '改签失败，请稍后再试',
                  confirmButtonText: '我知道了',
                  confirm: () => {
                    console.log('我知道了')
                  },
                  cancel: () => {}
                })
              }
            } else {
              mpx.showToast({
                title: LOAD_FAIL_CONTENT,
                icon: 'error'
              })
            }
          })
          .catch((e) => {
            mpx.showToast({
              title: LOAD_FAIL_CONTENT,
              icon: 'error'
            })
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      // 填写手机号码
      onPhoneChange(event) {
        this.phoneNum = event.detail.value
        this.phoneCheckDesc = ''
      },
      // 选座位
      onSeatClick(event) {
        const { value, index } = event?.detail || {}
        this.selectSeatType[index] = value
      },
      // 静音坐席
      onSilentClick(event) {
        this.isSilent = event.detail
      },
      // 静音车厢提示
      showTips() {
        Dialog.alert({
          title: '温馨提示',
          message:
            '"静音车厢"内旅客应保持安静，将手机调至静音或震动，如需拨打电话或相互交谈，需离开“静音车厢”。使用各类电子设备需佩戴耳机或关闭音源外放功能。不建议携带婴幼儿的旅客选择"静音车厢"',
          confirmButtonText: '我知道了',
          confirm: () => {
            console.log('我知道了')
          },
          cancel: () => {}
        })
      },
      // 时刻表
      closeSSI() {
        this.showStayInfo = false
      },
      showSSI(e) {
        const trainDetail = e?.detail || {}
        const train_code = trainDetail?.train_code || ''
        const train_no = trainDetail?.train_no || ''
        const info = {
          train_date: formatDate(trainDetail?.start_time),
          train_code: train_code,
          train_no: train_no,
          from_station_name: trainDetail?.from_station_name || '',
          to_station_name: trainDetail?.to_station_name || '',
        }
        this.stayInfo = info
        this.showStayInfo = true
      },
      // 预定 点击添加乘车人
      addPassenger() {
        if(!this.getTravelListFlag) return
        if (this.orderBaseData === null) {
          return
        }
        let min = 9
        this.selectSeatInfo?.forEach(item => {
          const ticket_num = item.ticket_num ?? ''
          if (ticket_num && ticket_num.endsWith('张')) {
            min = Math.min(min,ticket_num.substring(0, ticket_num?.length - 1))
          }
        })
        const max = this.isFromScramble
          ? 9
          : (this.fromChangeTicket || this.isTransfer)
            ? 5 
            : min
        this.setContactSelected(
          this.currentPassengerList.filter((item) => this.curPassengerIndexList.includes(item.id))
        )
        innerRouter.push(pagePath().CONTACTSELECT, {
          category: 'train',
          categoryOverTipsConfig : this.fromChangeTicket? 'trainChange': this.isTransfer ? 'trainUnion' : 'train',
          need_card: 1, // 接口返回是否需要证件信息
          max: max, // 最多可以选择的人数 这块需要 当前差旅单可定人数 与 当前车的票数做对比 需要腊生加字段 后续添加
          selected: this.currentPassengerList
            .filter((item) => this.curPassengerIndexList.includes(item.id))
            .map((item) => item.id + '_' + item.id_type + '_' + item.sub_type)
            .join(','),
          rule_owner: '',
        })
      },
      // 预定设置乘车人可选项
      setPassengerList({ detail }) {
        this.currentPassengerList = detail
      },
      // 预定选择乘车人
      setCurPassengerIndexList({ detail }) {
        const length = this.selectSeatInfo?.length ?? 1
        this.selectSeatType = Array(length).fill([])
        this.curPassengerIndexList = detail
      },
      // 改签选择乘车人
      checkPassengersForChange({ detail }) {
        this.checkedPassengersForChange = detail
      },
      changeDetail() {
        if(!this.canPay) return
        this.isDetailShow = !this.isDetailShow
      },
      closeDetail() {
        this.isDetailShow = false
      },
      closeDeadline() {
        this.showDeadline = false
      },
      openDeadLine() {
        this.showDeadline = true
      },
      setSelectDeadline({ detail }){
        this.selectDeadline = detail
        this.closeDeadline()
      },
      setSelectDateCurList({ detail }) {
        if(detail === this.curDateIndex) {
          return mpx.showToast({
            title: '当前选中项不可取消',
            icon: 'error'
          })
        }
        if(this.selectDateCurList.includes(detail)){
          this.selectDateCurList = this.selectDateCurList?.filter(item => item !== detail);
        }
        else this.selectDateCurList?.push(detail)
      },
      setSelectSeatCodeList({ detail }) {
        if(detail === this.selectSeatInfo[0].seat_type_name) {
          return mpx.showToast({
            title: '当前选中项不可取消',
            icon: 'error'
          })
        }
        if(this.selectSeatCodeList.includes(detail)){
          this.selectSeatCodeList = this.selectSeatCodeList?.filter(item => item !== detail);
        }
        else this.selectSeatCodeList?.push(detail)
      },
      deadlineAdapt() {
        const targetTime = new Date(this.curTrainInfo?.start_time) || new Date()
        const now = new Date()
        const timeDifference = targetTime - now
        if(timeDifference >= 7200000) this.selectDeadline = 2
        else if(timeDifference >= 3600000 ) this.selectDeadline = 1
        else this.selectDeadline = 0.5
      },
      handleScroll({ detail }) {
        this.scrollTop = detail
      },
      closeLoginDrawer() {
        this.setShowLoginDrawer(false)
      },
      openLoginDrawer() {
        this.setShowLoginDrawer(true)
      },
      closeTicketNotice() {
        this.showticketNotice = false
      },
      openTicketNotice() {
        this.showticketNotice = true
      },
      closeTikcetPrompt() {
        this.showtikcetPrompt = false
      },
      openTikcetPrompt() {
        this.showtikcetPrompt = true
      },
      opensLogin12306Drawer() {
        this.showLogin12306Drawer = true
      },
      openRightsDescDrawer() {
        this.showRightsDescDrawer = true
      },
      closeRightsDescDrawer() {
        this.showRightsDescDrawer = false
      },
      openWorryFreeDescDrawer() {
        this.showWorryFreeDescDrawer = true
      },
      closeWorryFreeDescDrawer() {
        this.showWorryFreeDescDrawer = false
      },
      openServiceDescDrawer(e) {
        const type = e.detail || this.selectRightInfo?.[0]?.type
        switch(type) {
          case 1:
            this.openRightsDescDrawer()
            break
          case 2: 
            this.openWorryFreeDescDrawer()
             break
        }
      },
       // 获取用户乘客列表
      async getUserContactsList(cb) {
        return DIDI_REQUEST(
          USER_CONTACTS_TOC,
          {
            order_type: this.isExemption,
            passenger_source: this.passengerSource,
            match_passengers: JSON.stringify(this.matchPassengers)
          },
          ({ data, code, message }) => {
            if (+code === 0) {
              cb(data?.list ?? [])
              this.errAccountFlag = false
            } else if(+code === 10612) {
              if(!this.isFromScramble){
                this.setIs12306Login(0)
                this.errAccountFlag = true
              }
              else {
                mpx.showToast({
                  title: message, //提示的内容,
                  icon: 'error', //图标,
                  duration: 3000 //持续的时间,
                })
              }
            }
            else {
              mpx.showToast({
                title: message, //提示的内容,
                icon: 'error' //图标,
              })
            }
          },
          () => {}
        )
      },
      // 默认勾选乘客
      async setDefaultPassenger() {
        await this.getUserContactsList(list => {
          const _list = list.filter( item => item.is_default_check)
          if(_list.length) {
            this.currentPassengerList = _list
            this.currentPassengerList.forEach(item => this.curPassengerIndexList.push(item.id))
            this.isRecommendTicket && this.setContactSelected(_list)
            }
        })
        this.curPassengerIndexList = [...new Set(this.curPassengerIndexList)]
        this.getTravelListFlag = true
        !this.isFromScramble && this.errAccountFlag && await this.setDefaultPassenger()
      },
      // login12306-drawer 登录12306成功后 重置乘车人数据 暂时没调用
      loginResetPassenger() {
        this.getUserContactsList(list => {
          let currentPassengerFourElementsList = []
          this.currentPassengerList.forEach(item => {
            const { id_no, id_type, passenger_name, passenger_type } = item || {}
            let use_id_no = AES_ECB_DECRYPT(id_no)
            use_id_no = `${use_id_no.slice(0,4)}_${use_id_no.slice(-3)}` // 身份证号解密后取前四后三
            currentPassengerFourElementsList.push(`${use_id_no}_${id_type}_${passenger_name}_${passenger_type}`)
          })
          const _newpassenger = list.filter(item => {
            const { id, id_no, id_type, passenger_name, passenger_type } = item || {}
            let use_id_no = AES_ECB_DECRYPT(id_no)
            use_id_no = `${use_id_no.slice(0,4)}_${use_id_no.slice(-3)}` // 身份证号解密后取前四后三
            // 相同的id
            const sameId = this.curPassengerIndexList.includes(id)
            // 相同的四要素 id_no,id_type,passenger_name,passenger_type
            const sameFourElements = currentPassengerFourElementsList.includes(`${use_id_no}_${id_type}_${passenger_name}_${passenger_type}`) // 相同的四要素
            return sameId || sameFourElements
          })
          this.currentPassengerList = _newpassenger
          this.curPassengerIndexList = []
          this.currentPassengerList.forEach(item => this.curPassengerIndexList.push(item.id))
          this.setContactSelected(this.currentPassengerList)
        })
      },
      // 校验乘车人列表 发生在本地列表和12306列表切换时
      async checkPassenger(type = 1) {
        this.matchPassengers = this.currentPassengerList?.map(item =>{
          return {
              passenger_name: item.passenger_name,
              id_no: item.id_no,
              id_name: item.id_name,
              encrypt_id_no: item.encrypt_id_no,
              passenger_type: item.passenger_type
            }
          })
        let list = []
        await this.getUserContactsList(_list => {
          this.errorPassengerList = _list.filter(item => item.not_exits)
          list = _list
          this.matchPassengers = []
        })
        this.currentPassengerList = list.filter(item => item.is_default_check)
        this.curPassengerIndexList = []
        this.currentPassengerList.forEach(item => this.curPassengerIndexList.push(item.id))
        if(this.errorPassengerList?.length) {
           this.openTikcetPrompt()
        }
        else {
          type && this.beforeSubmitOrder()
        }
      },
      async handleVerification(detail) {
        // 0为12306卡片点击 1是免登点击 2为提示条登录
        if(detail === 0) {
          this.checkForBack = 1
          innerRouter.push(pagePath().LOGIN12306)
        }
        // 卡片免登点击且未登录 直接免登下单
        else if(detail === 1  && !this.is12306Login) {
          this.setMakeOrderLoginType(1)
          // 基础服务的话切换成便携购票
          this.beforeSubmitOrder(false)
        }
        else if(detail === 1) {
          this.setMakeOrderLoginType(1)
          this.checkPassenger()
        }
        else if(detail === 2) {
          this.checkForBack = 2
          innerRouter.push(pagePath().LOGIN12306)
        }
      },
      fetchUserState() {
        return this.getCurrentUserReverse()
          .then(({ data, success, message, code }) => {
            if (success) {
              if (code === '0') {
                const { is_login } = data || {}
                this.setIs12306Login(is_login)
              }
              else {
                mpx.showToast({
                  title: message || LOAD_FAIL_CONTENT, //提示的内容,
                  icon: 'error', //图标,
                })
              }
              //12306默认返回1 航天根据状态返回 0 或者 1
            } else {
              mpx.showToast({
                title: LOAD_FAIL_CONTENT, //提示的内容,
                icon: 'success', //图标,
              })
            }
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      getDays(timeStamp, canCheck) {
        const weeks = ['日', '一', '二', '三', '四', '五', '六']
        const { week, day } = getFullDate(timeStamp)
        const item = {
          canCheck,
          timeStamp,
          weekText: '周' + weeks[week],
          dateText: formatDate(timeStamp, 'M月d日')
        }
        return item
      },
      updateHighestPrice(item) {
        const curTrainList = [...this.scrambleChooseTrains]
        const curTrain = curTrainList?.find(v => v.train_no === item.train_no)
        const curSeat = curTrain?.ticket_data?.find(v => v.seat_type_name === item.seat_name)
        if(!curSeat) return
        curSeat.highest_ticket_price = item.ticket_price
        curSeat.ticket_price = item.ticket_price
        this.setScrambleChooseTrains(curTrainList)
      },
      setStayInfo(e) {
        this.stayInfo = e?.detail ?? {}
      },
      notSleeperSeat(item,index) {
        return !!this.makeOrderInfo?.is_support_choose_seats[index] &&
         item?.seat_type && !['0',...SLEEPER_SEAT_TYPE].includes(item.seat_type)
      },
      getServiceDescription() {
        this.showServiceDescription = true
      },
      closeServiceDescription() {
        this.showServiceDescription = false
      },
      // 选中权益卡片
      selectSeatRights(){
        this.hasRightsChoosed = true
      },
      resetSeatRights(){
        this.hasRightsChoosed = false
      },
      async gotoAuthorizationAgreement () {
        let goToUrl =
          'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2\u0026policy_id=50071874'
        innerRouter.goTo(goToUrl)
      },
      // 弹窗选择退改无忧权益
      chooseWorryFreeService() {
        const choseFun = this.$refs?.rightsSelectGroup?.$refs?.['card2']?.[0]?.handleClick
        choseFun && choseFun(false)
        this.closeWorryFreeDescDrawer()
      },
      changeToExemptionService() {
        const newRightInfo = this.selectSeatInfo.map((item) => {
          return item?.service_info?.offlineService ?? {}
        })
        this.setSelectRightInfo(newRightInfo)
      },
      inputBlur() {
        const inputRefArr = ['telephone']
        inputRefArr.forEach((item) => {
            this.$refs?.[item]?.$el?.blur && this.$refs?.[item]?.$el?.blur()
        })
      }
    },
    onUnload() {
      this.closeLoginDrawer()
      this.setScrambleChooseTrains([])
      this.setSelectRightInfo([])
    },
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .scrambling-bg
    width 100%
    position absolute
  .make-order-custom-class
    /deep/ .es-main
      background #F2F6F9
  /deep/ .scramble-navbar
    height 52px
  /deep/ .white-navbar
    background-color #fff
  /deep/ .white-fillbox
    position relative
    z-index 1
    background-color #fff
  .es-navbar-title
    font-size 18px
    font-weight 600
    color #000004
    font-weight PingFangSC
  .es-navbar-right
    font-size 12px
    color $train-color-333
    font-family PingFangSC-Regular
  .card-main
    display flex
    flex-direction column
    padding 0px 12px 130px 12px
    box-sizing border-box
    min-height 100%
    overflow-x hidden
    overflow-y auto
    position relative
    &.notscramble
      background-color #F2F6F9
    .scramble-text-pic
      width 193px
      height 28px
      margin-bottom 12px
  .new-train-card
    margin 0 -12px
    padding 0 10px 0
    background #fff
    padding-top 6px
    .selected-seat-info
      padding-left 14px
      margin-top 10px
      line-height 14px
      font-size 14px
      color #333
      font-family PingFangSC-Medium
      font-weight 500
  .account
    display flex
    flex-direction row
    background white
    align-items center
    &.out
      border-radius 8px
      height 48px
      padding 0px 12px
      justify-content space-between
    &.in
      justify-content space-between
  .account-name
    font-size 16px
    color black
    font-weight 500
    margin-left 8px
    text-overflow ellipsis
    overflow hidden
  .protocol
    font-size 12px
    display inline
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color $train-color-999
    &.url
      color $train-color-333
      text-overflow ellipsis
  .account-status
    font-size 14px
    color $train-color-999
  .contact-card
    border-radius 8px
    background white
    padding 5px 12px 10px
  .contact-tips
    color #999999
    font-size 12px
    margin-top 8px
  .contact-phone
    background-color #fff
    display flex
    border-radius 12px
    font-size 14px
    font-family PingFang SC
    padding 14px
    padding-bottom 2px
    margin-bottom 10px
    .form-label
      font-family PingFangSC-Semibold
      font-size 16px
      letter-spacing 0px
      color #333
      margin-right 16px
    .form-value
      flex 1
      .error-tip
        color red
        min-height 8px
        margin-top 3px
        font-size 12px
        &.active
          border-bottom 1px red solid
    .contact-item
      height 20px
      line-height 20px
      display flex
      align-items center
      min-height unset
      &.contact-phone-input
        height 20px
        line-height 20px
        font-size 16px
        color #666
        outline none
  .scramble-icon-wrapper
    width 100%
    display flex
    justify-content center
    margin-top 14px
    .scramble-icon
      height 41px
      width 224px
  .footer
    box-sizing border-box
    align-items center
    &-fixed
      z-index 10002
    background-color #ffffff
    box-sizing border-box
    .exemption-tips
      display flex
      flex-direction row
      justify-content space-between
      padding 13px 14px 17px 16px
      background linear-gradient(0deg, #FFF6F1, #FFF6F1), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
      .exemption-tips-price
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0px;
        color: #FF6400;
      .exemption-tips-text
        font-family: PingFang SC;
        font-size: 10px;
        font-weight: normal;
        line-height: 14px;
        text-align: right;
        letter-spacing: 0px;
        color: #666666;

  .divider
    height 10px
  .no-account
    display flex
    justify-content space-between
    padding 16px 14px
    align-items center
    background-color #fff
    border-radius 8px
    margin-bottom 8px
    .no-account-left
      display flex
      align-items center
      .no-account-left-icon
        height 18px
        width 16px
        margin-right 5px
      .no-account-left-text
        color #333
        font-family PingFangSC-Semibold
      font-size 16px
        line-height 16px
    .no-account-right
      display flex
      align-items center
      .no-account-right-text
        color #999
        margin-right 4.5px
        font-family PingFangSC-Regular
        font-size 14px
        line-height 14px
      .no-account-right-icon
        width 4.5px
        height 8px
  .seat-info
    display flex
    position relative
    justify-content space-between
    align-items flex-end
    padding 32px 14px 12px 14px
    background #C1DDFF
    color #333
    border-radius 10px
    transform translateY(-20px)
    &-left
      display flex
      line-height 14px
      font-size 14px
      &-type
        font-family PingFangSC-Medium
      &-price
        margin-left 5px
        font-family PingFangSC-Regular
      .service-writting
        margin-left 12px
        position relative
        &::before
          content ''
          height 10px
          width 0.5px
          position absolute
          top 50%
          left -6px
          background-color #999999
          transform translateY(-50%)
    &-right
      display flex
      font-family PingFangSC-Regular
      font-size 12px
      line-height 12px
      text-align right
      color #333
      align-items center
      &-image
        width 10px
        height 10px
        margin-right 2px
  .passenger-card
    background-color #fff
    margin-bottom 10px
    padding 0 12px
    border-radius 12px
    &-add
      display flex
      align-items center
      justify-content center
      width 100%
      border-radius 8px
      margin 0 auto
      font-size 15px
      line-height 48px
      text-align center
      color #FF6400
      &-icon
        height 15px
        width 15px
        margin-right 4px
      &-text
        font-family PingFangSC-Medium
      .passenger-add-text-black
        color #333
  input::-webkit-input-placeholder
    color #cccccc
    font-family PingFangSC
  .protocol-container
    margin-top 9px
    margin-left 4px
    div
      display inline
  .protocol-text
    font-size 11px
    font-family PingFangSC-Regular
    color #999999
  .protocol-url
    font-size 11px
    font-family PingFangSC-Regular
    color #FF6400
  .text-color
    color $train-color-999
  .url-color
    color $train-color-666
  .slogan
    position absolute
    bottom 60px
    left 50%
    transform translateX(-50%)
    margin 0
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
</style>

<script name="json">
  module.exports = {
    usingComponents: {
      'select-seat-card': './components/order-select-seat-card',
      'passenger-change-check-list': './components/passenger-change-check-list',
      'change-tip': './components/change-tip',
      'passenger-make-order-card': './components/passenger-make-order-card',
      'train-information-new': '@/components/train-information-new',
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'es-riskmanagement': '@/pages/login12306/components/rm/risk-management',
      'order-bottom-bar': './components/order-bottom-bar',
      'es-descriptions': '@didi/es-mpx-ui/lib/descriptions',
      'es-card-wrap1': '@didi/es-mpx-ui/lib/card/card-wrap1',
      'change-navbar': '@/components/change-navbar',
      'order-common-card': '@/components/order-common-card',
      'es-over-layout': '@/es-mpx-ui/lib/layout',
      'price-detail-info-alter': '@/components/price-detail-info-alter',
      'scramble-select-card': './components/scramble-select-card',
      'deadline-drawer': './components/deadline-drawer',
      'probability': './components/probability',
      'login-drawer': './components/login-drawer',
      'ticketing-notice-drawer': './components/ticketing-notice-drawer',
      'dual-channel': '@/components/dual-channel',
      'transfer-info-card': './components/transfer-info-card',
      'stay-info-drawer': '@/components/stay-info-drawer',
      'seat-information-new': '@/components/seat-information-new',
      'seat-information-recommend': '@/components/seat-information-new/seat-information-recommend',
      'nologin-description': '@/pages/train-detail/components/nologin-description',
      'date-card': '@/pages/train-detail/components/date-card',
      'recommend-ticket-card': '@/components/recommend-ticket/recommend-ticket-card',
      'package-channel': './components/package-channel',
      'login12306-drawer': '@/components/login12306-drawer',
      'seat-rights-select-group': './components/seat-rights-select-group',
      'seat-information-group': '@/components/seat-information-new/seat-information-group',
      'rights-description-drawer': './components/rights-description-drawer',
      'service-desc-bar': './components/service-desc-bar',
      'make-order-service-business': './components/make-order-service-business',
      'Slogan': '@/components/slogan',
      'worry-free-cancellation-drawer': './components/worry-free-cancellation-drawer',
      'ticket-retention-drawer': './components/ticket-retention-drawer',
      'scramble-retention-drawer': './components/scramble-retention-drawer',
      'coupon-banner-simplify': '@/components/coupon/coupon-banner-simplify',
    }
  }
</script>